// GENERATED FILE, PLEASE DO NOT EDIT
var BackgroundPrimary = '#ffffff';
var BackgroundPrimaryInverted = '#191919';
var BackgroundSecondary = '#F7F7F7';
var BackgroundSecondaryInverted = '#313131';
var BackgroundTertiary = '#E7E7E7';
var BackgroundElevated = '#ffffff';
var BackgroundOverlay = '#191919';
var BackgroundSeparator = '#F7F7F7';
var BannerDefaultBackground = '#F7F7F7';
var BannerDefaultForeground = '#191919';
var BannerDefaultIcon = '#191919';
var BannerHighlightBackground = '#ECFCFC';
var BannerHighlightForeground = '#191919';
var BannerHighlightIcon = '#00666D';
var BannerInformationalBackground = '#494949';
var BannerInformationalForeground = '#ffffff';
var BannerInformationalIcon = '#ffffff';
var BannerNegativeBackground = '#FFF0ED';
var BannerNegativeForeground = '#191919';
var BannerNegativeIcon = '#B71000';
var BannerPositiveBackground = '#E7FBEF';
var BannerPositiveForeground = '#191919';
var BannerPositiveIcon = '#00872F';
var BannerWarningBackground = '#FFFFA3';
var BannerWarningForeground = '#191919';
var BannerWarningIcon = '#D5A600';
var BannerHighlightDefaultBackground = '#ECFCFC';
var BannerHighlightDefaultForeground = '#191919';
var BannerHighlightDefaultIcon = '#00666D';
var BannerHighlightEmphasisBackground = '#00838A';
var BannerHighlightEmphasisForeground = '#ffffff';
var BannerHighlightEmphasisIcon = '#ffffff';
var BannerInformationalDefaultBackground = '#F7F7F7';
var BannerInformationalDefaultForeground = '#191919';
var BannerInformationalDefaultIcon = '#191919';
var BannerInformationalEmphasisBackground = '#494949';
var BannerInformationalEmphasisForeground = '#ffffff';
var BannerInformationalEmphasisIcon = '#ffffff';
var BannerNegativeDefaultBackground = '#FFF0ED';
var BannerNegativeDefaultForeground = '#191919';
var BannerNegativeDefaultIcon = '#B71000';
var BannerNegativeEmphasisBackground = '#B71000';
var BannerNegativeEmphasisForeground = '#ffffff';
var BannerNegativeEmphasisIcon = '#ffffff';
var BannerPositiveDefaultBackground = '#E7FBEF';
var BannerPositiveDefaultForeground = '#191919';
var BannerPositiveDefaultIcon = '#00872F';
var BannerPositiveEmphasisBackground = '#00872F';
var BannerPositiveEmphasisForeground = '#ffffff';
var BannerPositiveEmphasisIcon = '#ffffff';
var BannerWarningDefaultBackground = '#FFFFA3';
var BannerWarningDefaultForeground = '#191919';
var BannerWarningDefaultIcon = '#D5A600';
var BannerWarningEmphasisBackground = '#F6E61B';
var BannerWarningEmphasisForeground = '#191919';
var BannerWarningEmphasisIcon = '#191919';
var BannerInformationalSubduedBackground = '#ffffff';
var BannerInformationalSubduedBorder = '#E7E7E7';
var BannerInformationalSubduedDecorator = '#494949';
var BannerInformationalSubduedForeground = '#191919';
var BannerInformationalSubduedIconBackground = '#E7E7E7';
var BannerInformationalSubduedIcon = '#767676';
var BannerHighlightSubduedBackground = '#ffffff';
var BannerHighlightSubduedBorder = '#E7E7E7';
var BannerHighlightSubduedDecorator = '#00838A';
var BannerHighlightSubduedForeground = '#191919';
var BannerHighlightSubduedIconBackground = '#ECFCFC';
var BannerHighlightSubduedIcon = '#00838A';
var BannerNegativeSubduedBackground = '#ffffff';
var BannerNegativeSubduedBorder = '#E7E7E7';
var BannerNegativeSubduedDecorator = '#B71000';
var BannerNegativeSubduedForeground = '#191919';
var BannerNegativeSubduedIconBackground = '#FFF0ED';
var BannerNegativeSubduedIcon = '#B71000';
var BannerPositiveSubduedBackground = '#ffffff';
var BannerPositiveSubduedBorder = '#E7E7E7';
var BannerPositiveSubduedDecorator = '#00872F';
var BannerPositiveSubduedForeground = '#191919';
var BannerPositiveSubduedIconBackground = '#E7FBEF';
var BannerPositiveSubduedIcon = '#00872F';
var BannerWarningSubduedBackground = '#ffffff';
var BannerWarningSubduedBorder = '#E7E7E7';
var BannerWarningSubduedDecorator = '#E8C500';
var BannerWarningSubduedForeground = '#191919';
var BannerWarningSubduedIconBackground = '#FFFFA3';
var BannerWarningSubduedIcon = '#A16C00';
var BorderPrimary = '#E7E7E7';
var BorderSecondary = '#D6D6D6';
var BorderFocus = '#b4c2fa';
var BorderError = '#B71000';
var BorderErrorDisabled = '#FDA294';
var BreadcrumbText = '#191919';
var BreadcrumbTextHovered = '#494949';
var BreadcrumbTextPressed = '#767676';
var BreadcrumbTextDisabled = '#B2B2B2';
var ButtonDefaultForeground = '#ffffff';
var ButtonDefaultForegroundDisabled = '#ffffff';
var ButtonDefaultForegroundHovered = '#ffffff';
var ButtonDefaultForegroundPressed = '#ffffff';
var ButtonDefaultToggleForeground = '#ffffff';
var ButtonDefaultToggleForegroundDisabled = '#C4C4C4';
var ButtonDefaultToggleForegroundHovered = '#ffffff';
var ButtonDefaultToggleForegroundOff = '#191919';
var ButtonDefaultToggleForegroundOffDisabled = '#8B8B8B';
var ButtonDefaultToggleForegroundOffHovered = '#191919';
var ButtonDefaultToggleForegroundOffPressed = '#191919';
var ButtonDefaultToggleForegroundPressed = '#ffffff';
var ButtonDestructiveBackground = '#B71000';
var ButtonDestructiveBackgroundHovered = '#D91400';
var ButtonDestructiveBackgroundPressed = '#810B00';
var ButtonDestructiveBackgroundDisabled = '#F7F7F7';
var ButtonDestructiveForeground = '#ffffff';
var ButtonDestructiveForegroundHovered = '#ffffff';
var ButtonDestructiveForegroundPressed = '#ffffff';
var ButtonDestructiveForegroundDisabled = '#B2B2B2';
var ButtonFabBackground = '#ffffff';
var ButtonFabBackgroundDisabled = '#ffffff';
var ButtonFabBackgroundHovered = '#F7F7F7';
var ButtonFabBackgroundPressed = '#F7F7F7';
var ButtonFabForeground = '#191919';
var ButtonFabForegroundDisabled = '#B2B2B2';
var ButtonFabForegroundHovered = '#191919';
var ButtonFabForegroundPressed = '#191919';
var ButtonFlatPrimaryBackground = '#ffffff';
var ButtonFlatPrimaryBackgroundHovered = '#E7E7E7';
var ButtonFlatPrimaryBackgroundPressed = '#E7E7E7';
var ButtonFlatPrimaryBackgroundDisabled = '#ffffff';
var ButtonFlatPrimaryForeground = '#EB1700';
var ButtonFlatPrimaryForegroundDisabled = '#B2B2B2';
var ButtonFlatPrimaryForegroundHovered = '#EB1700';
var ButtonFlatPrimaryForegroundPressed = '#EB1700';
var ButtonFlatSecondaryBackground = '#ffffff';
var ButtonFlatSecondaryBackgroundHovered = '#E7E7E7';
var ButtonFlatSecondaryBackgroundPressed = '#E7E7E7';
var ButtonFlatSecondaryBackgroundDisabled = '#ffffff';
var ButtonFlatSecondaryForeground = '#191919';
var ButtonFlatSecondaryForegroundDisabled = '#B2B2B2';
var ButtonFlatSecondaryForegroundHovered = '#191919';
var ButtonFlatSecondaryForegroundPressed = '#191919';
var ButtonLinkForeground = '#191919';
var ButtonLinkForegroundHovered = '#494949';
var ButtonLinkForegroundPressed = '#767676';
var ButtonLinkForegroundDisabled = '#B2B2B2';
var ButtonPlainBackground = '#ffffff';
var ButtonPlainBackgroundDisabled = '#ffffff';
var ButtonPlainBackgroundHovered = '#ffffff';
var ButtonPlainBackgroundPressed = '#ffffff';
var ButtonPlainForeground = '#494949';
var ButtonPlainForegroundDisabled = '#767676';
var ButtonPlainForegroundHovered = '#494949';
var ButtonPlainForegroundPressed = '#494949';
var ButtonPlainToggleBackground = '#ffffff';
var ButtonPlainToggleBackgroundDisabled = '#ffffff';
var ButtonPlainToggleBackgroundHovered = '#ffffff';
var ButtonPlainToggleBackgroundOff = '#ffffff';
var ButtonPlainToggleBackgroundOffDisabled = '#ffffff';
var ButtonPlainToggleBackgroundOffHovered = '#ffffff';
var ButtonPlainToggleBackgroundOffPressed = '#ffffff';
var ButtonPlainToggleBackgroundPressed = '#ffffff';
var ButtonPlainToggleForeground = '#494949';
var ButtonPlainToggleForegroundDisabled = '#767676';
var ButtonPlainToggleForegroundHovered = '#494949';
var ButtonPlainToggleForegroundOff = '#494949';
var ButtonPlainToggleForegroundOffDisabled = '#767676';
var ButtonPlainToggleForegroundOffHovered = '#494949';
var ButtonPlainToggleForegroundOffPressed = '#494949';
var ButtonPlainToggleForegroundPressed = '#494949';
var ButtonPrimaryBackground = '#EB1700';
var ButtonPrimaryBackgroundDisabled = '#F7F7F7';
var ButtonPrimaryBackgroundHovered = '#D91400';
var ButtonPrimaryBackgroundPressed = '#B71000';
var ButtonPrimaryForeground = '#ffffff';
var ButtonPrimaryForegroundDisabled = '#B2B2B2';
var ButtonPrimaryForegroundHovered = '#ffffff';
var ButtonPrimaryForegroundPressed = '#ffffff';
var ButtonPrimaryToggleBackground = '#191919';
var ButtonPrimaryToggleBackgroundDisabled = '#D6D6D6';
var ButtonPrimaryToggleBackgroundHovered = '#606060';
var ButtonPrimaryToggleBackgroundOff = '#E7E7E7';
var ButtonPrimaryToggleBackgroundOffDisabled = '#F7F7F7';
var ButtonPrimaryToggleBackgroundOffHovered = '#F7F7F7';
var ButtonPrimaryToggleBackgroundOffPressed = '#D6D6D6';
var ButtonPrimaryToggleBackgroundPressed = '#494949';
var ButtonPrimaryToggleBorderOff = '#E7E7E7';
var ButtonPrimaryToggleBorderOffHovered = '#F7F7F7';
var ButtonPrimaryToggleBorderOffPressed = '#D6D6D6';
var ButtonPrimaryToggleBorderOffDisabled = '#F7F7F7';
var ButtonPrimaryToggleBorderOn = '#191919';
var ButtonPrimaryToggleBorderOnHovered = '#606060';
var ButtonPrimaryToggleBorderOnPressed = '#494949';
var ButtonPrimaryToggleBorderOnDisabled = '#D6D6D6';
var ButtonPrimaryToggleForeground = '#ffffff';
var ButtonPrimaryToggleForegroundDisabled = '#9F9F9F';
var ButtonPrimaryToggleForegroundHovered = '#ffffff';
var ButtonPrimaryToggleForegroundOff = '#191919';
var ButtonPrimaryToggleForegroundOffDisabled = '#B2B2B2';
var ButtonPrimaryToggleForegroundOffHovered = '#191919';
var ButtonPrimaryToggleForegroundOffPressed = '#191919';
var ButtonPrimaryToggleForegroundPressed = '#ffffff';
var ButtonSecondaryBackground = '#FFF0ED';
var ButtonSecondaryBackgroundDisabled = '#F7F7F7';
var ButtonSecondaryBackgroundHovered = '#FFE0DB';
var ButtonSecondaryBackgroundPressed = '#FEC7BD';
var ButtonSecondaryForeground = '#D91400';
var ButtonSecondaryForegroundDisabled = '#B2B2B2';
var ButtonSecondaryForegroundHovered = '#D91400';
var ButtonSecondaryForegroundPressed = '#D91400';
var ButtonSecondaryToggleBackground = '#191919';
var ButtonSecondaryToggleBackgroundDisabled = '#D6D6D6';
var ButtonSecondaryToggleBackgroundHovered = '#606060';
var ButtonSecondaryToggleBackgroundPressed = '#494949';
var ButtonSecondaryToggleBackgroundOff = '#E7E7E7';
var ButtonSecondaryToggleBackgroundOffDisabled = '#F7F7F7';
var ButtonSecondaryToggleBackgroundOffHovered = '#F7F7F7';
var ButtonSecondaryToggleBackgroundOffPressed = '#D6D6D6';
var ButtonSecondaryToggleBorderOff = '#E7E7E7';
var ButtonSecondaryToggleBorderOffHovered = '#F7F7F7';
var ButtonSecondaryToggleBorderOffPressed = '#D6D6D6';
var ButtonSecondaryToggleBorderOffDisabled = '#F7F7F7';
var ButtonSecondaryToggleBorderOn = '#191919';
var ButtonSecondaryToggleBorderOnHovered = '#606060';
var ButtonSecondaryToggleBorderOnPressed = '#494949';
var ButtonSecondaryToggleBorderOnDisabled = '#D6D6D6';
var ButtonSecondaryToggleForeground = '#ffffff';
var ButtonSecondaryToggleForegroundDisabled = '#9F9F9F';
var ButtonSecondaryToggleForegroundHovered = '#ffffff';
var ButtonSecondaryToggleForegroundPressed = '#ffffff';
var ButtonSecondaryToggleForegroundOff = '#191919';
var ButtonSecondaryToggleForegroundOffDisabled = '#B2B2B2';
var ButtonSecondaryToggleForegroundOffHovered = '#191919';
var ButtonSecondaryToggleForegroundOffPressed = '#191919';
var ButtonTertiaryBackground = '#E7E7E7';
var ButtonTertiaryBackgroundDisabled = '#F7F7F7';
var ButtonTertiaryBackgroundHovered = '#C4C4C4';
var ButtonTertiaryBackgroundPressed = '#C4C4C4';
var ButtonTertiaryBorder = '#E7E7E7';
var ButtonTertiaryBorderDisabled = '#F7F7F7';
var ButtonTertiaryBorderHovered = '#C4C4C4';
var ButtonTertiaryBorderPressed = '#C4C4C4';
var ButtonTertiaryForeground = '#191919';
var ButtonTertiaryForegroundDisabled = '#B2B2B2';
var ButtonTertiaryForegroundHovered = '#191919';
var ButtonTertiaryForegroundPressed = '#191919';
var ButtonTertiaryToggleBackground = '#191919';
var ButtonTertiaryToggleBackgroundDisabled = '#D6D6D6';
var ButtonTertiaryToggleBackgroundHovered = '#606060';
var ButtonTertiaryToggleBackgroundOff = '#ffffff';
var ButtonTertiaryToggleBackgroundOffDisabled = '#F7F7F7';
var ButtonTertiaryToggleBackgroundOffHovered = '#D6D6D6';
var ButtonTertiaryToggleBackgroundOffPressed = '#E7E7E7';
var ButtonTertiaryToggleBackgroundPressed = '#494949';
var ButtonTertiaryToggleBorderOff = '#191919';
var ButtonTertiaryToggleBorderOffHovered = '#606060';
var ButtonTertiaryToggleBorderOffPressed = '#494949';
var ButtonTertiaryToggleBorderOffDisabled = '#F7F7F7';
var ButtonTertiaryToggleBorderOn = '#191919';
var ButtonTertiaryToggleBorderOnHovered = '#606060';
var ButtonTertiaryToggleBorderOnPressed = '#494949';
var ButtonTertiaryToggleBorderOnDisabled = '#D6D6D6';
var ButtonTertiaryToggleForeground = '#ffffff';
var ButtonTertiaryToggleForegroundDisabled = '#9F9F9F';
var ButtonTertiaryToggleForegroundHovered = '#ffffff';
var ButtonTertiaryToggleForegroundPressed = '#ffffff';
var ButtonTertiaryToggleForegroundOff = '#191919';
var ButtonTertiaryToggleForegroundOffDisabled = '#B2B2B2';
var ButtonTertiaryToggleForegroundOffHovered = '#191919';
var ButtonTertiaryToggleForegroundOffPressed = '#191919';
var ButtonPrimaryToggleGroupBackgroundOff = '#E7E7E7';
var ButtonPrimaryToggleGroupBackgroundOffHovered = '#D6D6D6';
var ButtonPrimaryToggleGroupBackgroundOffPressed = '#D6D6D6';
var ButtonPrimaryToggleGroupBackgroundOffDisabled = '#F7F7F7';
var ButtonPrimaryToggleGroupBorderOff = '#E7E7E7';
var ButtonPrimaryToggleGroupBorderOffHovered = '#D6D6D6';
var ButtonPrimaryToggleGroupBorderOffPressed = '#D6D6D6';
var ButtonPrimaryToggleGroupBorderOffDisabled = '#F7F7F7';
var ButtonPrimaryToggleGroupForegroundOff = '#191919';
var ButtonPrimaryToggleGroupForegroundOffHovered = '#191919';
var ButtonPrimaryToggleGroupForegroundOffPressed = '#191919';
var ButtonPrimaryToggleGroupForegroundOffDisabled = '#B2B2B2';
var ButtonPrimaryToggleGroupBackgroundOn = '#191919';
var ButtonPrimaryToggleGroupBackgroundOnHovered = '#606060';
var ButtonPrimaryToggleGroupBackgroundOnPressed = '#494949';
var ButtonPrimaryToggleGroupBackgroundOnDisabled = '#D6D6D6';
var ButtonPrimaryToggleGroupBorderOn = '#191919';
var ButtonPrimaryToggleGroupBorderOnHovered = '#606060';
var ButtonPrimaryToggleGroupBorderOnPressed = '#494949';
var ButtonPrimaryToggleGroupBorderOnDisabled = '#D6D6D6';
var ButtonPrimaryToggleGroupForegroundOn = '#ffffff';
var ButtonPrimaryToggleGroupForegroundOnHovered = '#ffffff';
var ButtonPrimaryToggleGroupForegroundOnPressed = '#ffffff';
var ButtonPrimaryToggleGroupForegroundOnDisabled = '#9F9F9F';
var ButtonSecondaryToggleGroupBackgroundOff = '#E7E7E7';
var ButtonSecondaryToggleGroupBackgroundOffHovered = '#D6D6D6';
var ButtonSecondaryToggleGroupBackgroundOffPressed = '#D6D6D6';
var ButtonSecondaryToggleGroupBackgroundOffDisabled = '#F7F7F7';
var ButtonSecondaryToggleGroupBorderOff = '#E7E7E7';
var ButtonSecondaryToggleGroupBorderOffHovered = '#D6D6D6';
var ButtonSecondaryToggleGroupBorderOffPressed = '#D6D6D6';
var ButtonSecondaryToggleGroupBorderOffDisabled = '#F7F7F7';
var ButtonSecondaryToggleGroupForegroundOff = '#191919';
var ButtonSecondaryToggleGroupForegroundOffHovered = '#191919';
var ButtonSecondaryToggleGroupForegroundOffPressed = '#191919';
var ButtonSecondaryToggleGroupForegroundOffDisabled = '#B2B2B2';
var ButtonSecondaryToggleGroupBackgroundOn = '#191919';
var ButtonSecondaryToggleGroupBackgroundOnHovered = '#606060';
var ButtonSecondaryToggleGroupBackgroundOnPressed = '#494949';
var ButtonSecondaryToggleGroupBackgroundOnDisabled = '#D6D6D6';
var ButtonSecondaryToggleGroupBorderOn = '#191919';
var ButtonSecondaryToggleGroupBorderOnHovered = '#606060';
var ButtonSecondaryToggleGroupBorderOnPressed = '#494949';
var ButtonSecondaryToggleGroupBorderOnDisabled = '#D6D6D6';
var ButtonSecondaryToggleGroupForegroundOn = '#ffffff';
var ButtonSecondaryToggleGroupForegroundOnHovered = '#ffffff';
var ButtonSecondaryToggleGroupForegroundOnPressed = '#ffffff';
var ButtonSecondaryToggleGroupForegroundOnDisabled = '#9F9F9F';
var ButtonTertiaryToggleGroupBackgroundOff = '#ffffff';
var ButtonTertiaryToggleGroupBackgroundOffHovered = '#D6D6D6';
var ButtonTertiaryToggleGroupBackgroundOffPressed = '#E7E7E7';
var ButtonTertiaryToggleGroupBackgroundOffDisabled = '#F7F7F7';
var ButtonTertiaryToggleGroupBorderOff = '#191919';
var ButtonTertiaryToggleGroupBorderOffHovered = '#606060';
var ButtonTertiaryToggleGroupBorderOffPressed = '#494949';
var ButtonTertiaryToggleGroupBorderOffDisabled = '#F7F7F7';
var ButtonTertiaryToggleGroupForegroundOff = '#191919';
var ButtonTertiaryToggleGroupForegroundOffHovered = '#191919';
var ButtonTertiaryToggleGroupForegroundOffPressed = '#191919';
var ButtonTertiaryToggleGroupForegroundOffDisabled = '#B2B2B2';
var ButtonTertiaryToggleGroupBackgroundOn = '#191919';
var ButtonTertiaryToggleGroupBackgroundOnHovered = '#606060';
var ButtonTertiaryToggleGroupBackgroundOnPressed = '#494949';
var ButtonTertiaryToggleGroupBackgroundOnDisabled = '#D6D6D6';
var ButtonTertiaryToggleGroupBorderOn = '#191919';
var ButtonTertiaryToggleGroupBorderOnHovered = '#606060';
var ButtonTertiaryToggleGroupBorderOnPressed = '#494949';
var ButtonTertiaryToggleGroupBorderOnDisabled = '#D6D6D6';
var ButtonTertiaryToggleGroupForegroundOn = '#ffffff';
var ButtonTertiaryToggleGroupForegroundOnHovered = '#ffffff';
var ButtonTertiaryToggleGroupForegroundOnPressed = '#ffffff';
var ButtonTertiaryToggleGroupForegroundOnDisabled = '#9F9F9F';
var ButtonFloatingToggleGroupBackgroundColorOff = '#ffffff';
var ButtonTabBackgroundOffDefault = '#ffffff';
var ButtonTabBackgroundOffHovered = '#F7F7F7';
var ButtonTabBackgroundOffPressed = '#E7E7E7';
var ButtonTabBackgroundOffDisabled = '#ffffff';
var ButtonTabBackgroundOnDefault = '#ffffff';
var ButtonTabBackgroundOnHovered = '#F7F7F7';
var ButtonTabBackgroundOnPressed = '#E7E7E7';
var ButtonTabBackgroundOnDisabled = '#ffffff';
var ButtonTabForegroundOffDefault = '#494949';
var ButtonTabForegroundOffHovered = '#494949';
var ButtonTabForegroundOffPressed = '#494949';
var ButtonTabForegroundOffDisabled = '#B2B2B2';
var ButtonTabForegroundOnDefault = '#191919';
var ButtonTabForegroundOnHovered = '#191919';
var ButtonTabForegroundOnPressed = '#191919';
var ButtonTabForegroundOnDisabled = '#9F9F9F';
var CardBackgroundDefault = '#ffffff';
var CardBackgroundHovered = '#ffffff';
var CardBackgroundPressed = '#ffffff';
var CardBackgroundDisabled = '#ffffff';
var CardBorderUnselectedDefault = '#E7E7E7';
var CardBorderUnselectedHovered = '#D6D6D6';
var CardBorderUnselectedPressed = '#C4C4C4';
var CardBorderUnselectedDisabled = '#F7F7F7';
var CardBorderUnselectedError = '#B71000';
var CardBorderUnselectedErrorDisabled = '#FDA294';
var CardBorderSelectedDefault = '#191919';
var CardBorderSelectedHovered = '#313131';
var CardBorderSelectedPressed = '#494949';
var CardBorderSelectedDisabled = '#B2B2B2';
var CardBorderSelectedError = '#B71000';
var CardBorderSelectedErrorDisabled = '#FDA294';
var CardTitleDefault = '#191919';
var CardTitleHovered = '#313131';
var CardTitlePressed = '#494949';
var CardTitleDisabled = '#B2B2B2';
var CardBodyDefault = '#494949';
var CardBodyHovered = '#606060';
var CardBodyPressed = '#767676';
var CardBodyDisabled = '#B2B2B2';
var ChatIncomingBackground = '#F7F7F7';
var ChatIncomingForeground = '#191919';
var ChatOutgoingBackground = '#191919';
var ChatOutgoingForeground = '#ffffff';
var DatePickerDateUnselectedBackground = '#ffffff';
var DatePickerDateUnselectedBackgroundHovered = '#D6D6D6';
var DatePickerDateUnselectedBackgroundPressed = '#C4C4C4';
var DatePickerDateUnselectedBackgroundDisabled = '#ffffff';
var DatePickerDateBorderUnselected = '#ffffff';
var DatePickerDateBorderUnselectedHovered = '#D6D6D6';
var DatePickerDateBorderUnselectedPressed = '#C4C4C4';
var DatePickerDateBorderUnselectedDisabled = '#ffffff';
var DatePickerDateForegroundUnselected = '#191919';
var DatePickerDateForegroundUnselectedHovered = '#191919';
var DatePickerDateForegroundUnselectedPressed = '#191919';
var DatePickerDateForegroundUnselectedDisabled = '#B2B2B2';
var DatePickerDateSelectedBackground = '#191919';
var DatePickerDateSelectedBackgroundHovered = '#606060';
var DatePickerDateSelectedBackgroundPressed = '#494949';
var DatePickerDateSelectedBackgroundDisabled = '#D6D6D6';
var DatePickerDateBorderSelected = '#191919';
var DatePickerDateBorderSelectedHovered = '#606060';
var DatePickerDateBorderSelectedPressed = '#494949';
var DatePickerDateBorderSelectedDisabled = '#D6D6D6';
var DatePickerDateForegroundSelected = '#ffffff';
var DatePickerDateForegroundSelectedHovered = '#ffffff';
var DatePickerDateForegroundSelectedPressed = '#ffffff';
var DatePickerDateForegroundSelectedDisabled = '#9F9F9F';
var DatePickerRangeUnselectedBackground = '#ffffff';
var DatePickerRangeUnselectedBackgroundHovered = '#F7F7F7';
var DatePickerRangeUnselectedBackgroundPressed = '#E7E7E7';
var DatePickerRangeUnselectedBackgroundDisabled = '#ffffff';
var DatePickerRangeBorderUnselected = '#ffffff';
var DatePickerRangeBorderUnselectedHovered = '#F7F7F7';
var DatePickerRangeBorderUnselectedPressed = '#E7E7E7';
var DatePickerRangeBorderUnselectedDisabled = '#ffffff';
var DatePickerRangeForegroundUnselected = '#191919';
var DatePickerRangeForegroundUnselectedHovered = '#191919';
var DatePickerRangeForegroundUnselectedPressed = '#191919';
var DatePickerRangeForegroundUnselectedDisabled = '#B2B2B2';
var DatePickerRangeSelectedBackground = '#D6D6D6';
var DatePickerRangeSelectedBackgroundHovered = '#C4C4C4';
var DatePickerRangeSelectedBackgroundPressed = '#B2B2B2';
var DatePickerRangeSelectedBackgroundDisabled = '#E7E7E7';
var DatePickerRangeBorderSelected = '#D6D6D6';
var DatePickerRangeBorderSelectedHovered = '#C4C4C4';
var DatePickerRangeBorderSelectedPressed = '#B2B2B2';
var DatePickerRangeBorderSelectedDisabled = '#E7E7E7';
var DatePickerRangeForegroundSelected = '#191919';
var DatePickerRangeForegroundSelectedHovered = '#191919';
var DatePickerRangeForegroundSelectedPressed = '#191919';
var DatePickerRangeForegroundSelectedDisabled = '#9F9F9F';
var DatePickerTodayBorderSelected = '#767676';
var DatePickerDateUnselectedIndicatorPrimary = '#B71000';
var DatePickerDateUnselectedIndicatorSecondary = '#494949';
var DatePickerDateUnselectedIndicatorDisabled = '#B2B2B2';
var DatePickerDateSelectedIndicatorPrimary = '#FDA294';
var DatePickerDateSelectedIndicatorSecondary = '#D6D6D6';
var DatePickerDateSelectedIndicatorDisabled = '#9F9F9F';
var DatePickerRangeSelectedIndicatorPrimary = '#B71000';
var DatePickerRangeSelectedIndicatorSecondary = '#494949';
var DatePickerRangeSelectedIndicatorDisabled = '#B2B2B2';
var DiagonalDefaultOverlay = '#ffffff';
var FieldsBackgroundActive = '#F7F7F7';
var FieldsBackgroundDisabled = '#F7F7F7';
var FieldsBackgroundError = '#FFF0ED';
var FieldsBackgroundInactive = '#F7F7F7';
var FieldsBorderActive = '#191919';
var FieldsBorderDisabled = '#F7F7F7';
var FieldsBorderError = '#B71000';
var FieldsBorderInactive = '#F7F7F7';
var FieldsForegroundActive = '#191919';
var FieldsForegroundDisabled = '#B2B2B2';
var FieldsForegroundError = '#191919';
var FieldsForegroundInactive = '#191919';
var FieldsForegroundPlaceholder = '#606060';
var FieldsIconDropdown = '#191919';
var FieldsIconSearch = '#191919';
var FieldsInputBackground = '#ffffff';
var FieldsInputBackgroundDisabled = '#F7F7F7';
var FieldsInputBorder = '#D6D6D6';
var FieldsInputBorderError = '#B71000';
var GlobalPrimary = '#EB1700';
var GlobalSecondary = '#00838A';
var ListCellContainerBackgroundDefault = '#ffffff';
var ListCellContainerBackgroundHovered = '#F7F7F7';
var ListCellContainerBackgroundPressed = '#E7E7E7';
var ListCellContainerBackgroundUnread = '#f4f6fe';
var ListCellContainerBackgroundUnreadHovered = '#d1dafb';
var ListCellContainerBackgroundUnreadPressed = '#e6ebfd';
var ListCellIconToggledOn = '#EB1700';
var ListCellIconToggledOff = '#494949';
var LoadingDefault = '#EB1700';
var MapCurrentLocationBackgroundDefault = '#4969f5';
var MapCurrentLocationBackgroundOverlay = '#6c87fb';
var MapCurrentLocationBorder = '#ffffff';
var MapDasherBackground = '#EB1700';
var MapDasherForeground = '#ffffff';
var MapDasherBorder = '#ffffff';
var MapPinSelectedBackgroundDefault = '#191919';
var MapPinSelectedBackgroundDisabled = '#B2B2B2';
var MapPinSelectedForegroundDefault = '#ffffff';
var MapPinSelectedForegroundDisabled = '#ffffff';
var MapPinSelectedBorderDefault = '#494949';
var MapPinSelectedBorderDisabled = '#B2B2B2';
var MapPinUnselectedBackgroundDefault = '#ffffff';
var MapPinUnselectedBackgroundDisabled = '#B2B2B2';
var MapPinUnselectedForegroundDefault = '#191919';
var MapPinUnselectedForegroundDisabled = '#ffffff';
var MapPinUnselectedBorderDefault = '#D6D6D6';
var MapPinUnselectedBorderDisabled = '#B2B2B2';
var MapPinUnselectedForegroundFood = '#F54323';
var MapPinUnselectedForegroundCoffee = '#643B00';
var MapPinUnselectedForegroundAlcohol = '#BD8800';
var MapPinUnselectedForegroundGroceries = '#006A25';
var MapRoutelineBackgroundDefault = '#191919';
var MapRoutelineBorder = '#191919';
var MapRoutelineNodeBackgroundDefault = '#ffffff';
var MapRoutelineNodeBorder = '#191919';
var MenuItemBackground = '#ffffff';
var MenuItemBackgroundHovered = '#F7F7F7';
var MenuItemBackgroundPressed = '#E7E7E7';
var MenuItemBackgroundDisabled = '#ffffff';
var MenuItemForeground = '#191919';
var MenuItemForegroundHovered = '#191919';
var MenuItemForegroundPressed = '#191919';
var MenuItemForegroundDisabled = '#B2B2B2';
var ModalBackground = '#ffffff';
var OverlayBackgroundDefault = '#191919';
var OverlayBackgroundLoading = '#ffffff';
var OverlayLoadingDefault = '#EB1700';
var PageBackgroundPrimary = '#ffffff';
var PageBackgroundSecondary = '#F7F7F7';
var PageBackgroundTertiary = '#E7E7E7';
var PaginationNumberedNavigationBackground = '#E7E7E7';
var PaginationNumberedNavigationBackgroundHovered = '#F7F7F7';
var PaginationNumberedNavigationBackgroundPressed = '#D6D6D6';
var PaginationNumberedNavigationBackgroundDisabled = '#F7F7F7';
var PaginationNumberedNavigationBorder = '#E7E7E7';
var PaginationNumberedNavigationBorderHovered = '#F7F7F7';
var PaginationNumberedNavigationBorderPressed = '#D6D6D6';
var PaginationNumberedNavigationBorderDisabled = '#F7F7F7';
var PaginationNumberedNavigationForeground = '#191919';
var PaginationNumberedNavigationForegroundHovered = '#191919';
var PaginationNumberedNavigationForegroundPressed = '#191919';
var PaginationNumberedNavigationForegroundDisabled = '#B2B2B2';
var PaginationNumberedSelectedBackground = '#191919';
var PaginationNumberedSelectedBackgroundDisabled = '#D6D6D6';
var PaginationNumberedSelectedBackgroundHovered = '#606060';
var PaginationNumberedSelectedBackgroundPressed = '#494949';
var PaginationNumberedSelectedBorder = '#191919';
var PaginationNumberedSelectedBorderDisabled = '#D6D6D6';
var PaginationNumberedSelectedBorderHovered = '#606060';
var PaginationNumberedSelectedBorderPressed = '#494949';
var PaginationNumberedSelectedForeground = '#ffffff';
var PaginationNumberedSelectedForegroundDisabled = '#9F9F9F';
var PaginationNumberedSelectedForegroundHovered = '#ffffff';
var PaginationNumberedSelectedForegroundPressed = '#ffffff';
var PaginationNumberedUnselectedBackground = '#E7E7E7';
var PaginationNumberedUnselectedBackgroundDisabled = '#F7F7F7';
var PaginationNumberedUnselectedBackgroundHovered = '#D6D6D6';
var PaginationNumberedUnselectedBackgroundPressed = '#D6D6D6';
var PaginationNumberedUnselectedBorder = '#E7E7E7';
var PaginationNumberedUnselectedBorderDisabled = '#F7F7F7';
var PaginationNumberedUnselectedBorderHovered = '#D6D6D6';
var PaginationNumberedUnselectedBorderPressed = '#D6D6D6';
var PaginationNumberedUnselectedForeground = '#191919';
var PaginationNumberedUnselectedForegroundDisabled = '#B2B2B2';
var PaginationNumberedUnselectedForegroundHovered = '#191919';
var PaginationNumberedUnselectedForegroundPressed = '#191919';
var PaginationSelectedDark = '#767676';
var PaginationSelectedPrimary = '#EB1700';
var PaginationSelectedLight = '#ffffff';
var PaginationUnselectedDark = '#D6D6D6';
var PaginationUnselectedPrimary = '#D6D6D6';
var PaginationUnselectedLight = '#8B8B8B';
var PopoverContainerBackground = '#ffffff';
var RatingSelected = '#E8C500';
var RatingUnselected = '#E7E7E7';
var RatingSelectedDisabled = '#B2B2B2';
var RatingUnselectedDisabled = '#F7F7F7';
var SliderKnobBackground = '#191919';
var SliderKnobBackgroundHovered = '#494949';
var SliderKnobBackgroundPressed = '#313131';
var SliderKnobBackgroundDisabled = '#D6D6D6';
var SliderTrackBackgroundOff = '#D6D6D6';
var SliderTrackBackgroundOffDisabled = '#F7F7F7';
var SliderTrackBackgroundOn = '#191919';
var SliderTrackBackgroundOnDisabled = '#D6D6D6';
var SliderTextOff = '#767676';
var SliderTextOn = '#191919';
var SliderTextOnDisabled = '#B2B2B2';
var SliderTextOffDisabled = '#D6D6D6';
var SliderIcon = '#191919';
var SliderIconDisabled = '#B2B2B2';
var QuantityStepperFloatingCollapsedSelectedBackgroundDefault = '#191919';
var QuantityStepperFloatingCollapsedSelectedBackgroundHover = '#313131';
var QuantityStepperFloatingCollapsedSelectedBackgroundPressed = '#313131';
var QuantityStepperFloatingCollapsedSelectedBackgroundDisabled = '#F7F7F7';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault = '#ffffff';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover = '#ffffff';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed = '#313131';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled = '#B2B2B2';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault = '#D6D6D6';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover = '#D6D6D6';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed = '#D6D6D6';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled = '#B2B2B2';
var QuantityStepperFloatingCollapsedUnselectedBackgroundDefault = '#ffffff';
var QuantityStepperFloatingCollapsedUnselectedBackgroundHover = '#E7E7E7';
var QuantityStepperFloatingCollapsedUnselectedBackgroundPressed = '#E7E7E7';
var QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled = '#F7F7F7';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault = '#191919';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover = '#191919';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed = '#191919';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled = '#B2B2B2';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault = '#494949';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover = '#494949';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed = '#494949';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled = '#B2B2B2';
var QuantityStepperFloatingExpandedBackgroundDefault = '#ffffff';
var QuantityStepperFloatingExpandedBackgroundHover = '#E7E7E7';
var QuantityStepperFloatingExpandedBackgroundPressed = '#E7E7E7';
var QuantityStepperFloatingExpandedBackgroundDisabled = '#F7F7F7';
var QuantityStepperFloatingExpandedForegroundPrimaryDefault = '#191919';
var QuantityStepperFloatingExpandedForegroundPrimaryHover = '#191919';
var QuantityStepperFloatingExpandedForegroundPrimaryPressed = '#191919';
var QuantityStepperFloatingExpandedForegroundPrimaryDisabled = '#B2B2B2';
var QuantityStepperFloatingExpandedForegroundSecondaryDefault = '#494949';
var QuantityStepperFloatingExpandedForegroundSecondaryHover = '#494949';
var QuantityStepperFloatingExpandedForegroundSecondaryPressed = '#494949';
var QuantityStepperFloatingExpandedForegroundSecondaryDisabled = '#B2B2B2';
var SwitchBackgroundOn = '#191919';
var SwitchBackgroundOnDisabled = '#D6D6D6';
var SwitchBackgroundOff = '#B2B2B2';
var SwitchBackgroundOffDisabled = '#D6D6D6';
var SwitchBorderOn = '#191919';
var SwitchBorderOnDisabled = '#D6D6D6';
var SwitchBorderOff = '#B2B2B2';
var SwitchBorderOffDisabled = '#D6D6D6';
var SwitchForegroundOn = '#ffffff';
var SwitchForegroundOff = '#ffffff';
var SwitchForegroundOnDisabled = '#F7F7F7';
var SwitchForegroundOffDisabled = '#F7F7F7';
var SwitchTrackOff = '#B2B2B2';
var SwitchTrackOffDisabled = '#D6D6D6';
var SwitchThumbOff = '#ffffff';
var SwitchThumbOffDisabled = '#F7F7F7';
var SwitchTrackOn = '#8B8B8B';
var SwitchTrackOnDisabled = '#D6D6D6';
var SwitchThumbOn = '#191919';
var SwitchThumbOnDisabled = '#B2B2B2';
var TableHeaderCellBackground = '#ffffff';
var TableBodyCellBackground = '#ffffff';
var TagDefaultBackground = '#E7E7E7';
var TagDefaultBorder = '#E7E7E7';
var TagDefaultForeground = '#191919';
var TagDefaultIcon = '#191919';
var TagHighlightBackground = '#00838A';
var TagHighlightBorder = '#00838A';
var TagHighlightForeground = '#ffffff';
var TagHighlightIcon = '#ffffff';
var TagInformationalBackground = '#494949';
var TagInformationalBorder = '#494949';
var TagInformationalForeground = '#ffffff';
var TagInformationalIcon = '#ffffff';
var TagNegativeBackground = '#B71000';
var TagNegativeBorder = '#B71000';
var TagNegativeForeground = '#ffffff';
var TagNegativeIcon = '#ffffff';
var TagPositiveBackground = '#E7FBEF';
var TagPositiveBorder = '#E7FBEF';
var TagPositiveForeground = '#006A25';
var TagPositiveIcon = '#006A25';
var TagWarningBackground = '#F6E61B';
var TagWarningBorder = '#F6E61B';
var TagWarningForeground = '#191919';
var TagWarningIcon = '#191919';
var TagInformationalDefaultBackground = '#E7E7E7';
var TagInformationalDefaultBorder = '#E7E7E7';
var TagInformationalDefaultForeground = '#191919';
var TagInformationalDefaultIcon = '#191919';
var TagInformationalEmphasisBackground = '#494949';
var TagInformationalEmphasisBorder = '#494949';
var TagInformationalEmphasisForeground = '#ffffff';
var TagInformationalEmphasisIcon = '#ffffff';
var TagNegativeDefaultBackground = '#FFF0ED';
var TagNegativeDefaultBorder = '#FFF0ED';
var TagNegativeDefaultForeground = '#B71000';
var TagNegativeDefaultIcon = '#B71000';
var TagNegativeEmphasisBackground = '#B71000';
var TagNegativeEmphasisBorder = '#B71000';
var TagNegativeEmphasisForeground = '#ffffff';
var TagNegativeEmphasisIcon = '#ffffff';
var TagPositiveDefaultBackground = '#E7FBEF';
var TagPositiveDefaultBorder = '#E7FBEF';
var TagPositiveDefaultForeground = '#006A25';
var TagPositiveDefaultIcon = '#006A25';
var TagPositiveEmphasisBackground = '#00872F';
var TagPositiveEmphasisBorder = '#00872F';
var TagPositiveEmphasisForeground = '#ffffff';
var TagPositiveEmphasisIcon = '#ffffff';
var TagWarningDefaultBackground = '#FFFFA3';
var TagWarningDefaultBorder = '#FFFFA3';
var TagWarningDefaultForeground = '#643B00';
var TagWarningDefaultIcon = '#643B00';
var TagWarningEmphasisBackground = '#F6E61B';
var TagWarningEmphasisBorder = '#F6E61B';
var TagWarningEmphasisForeground = '#191919';
var TagWarningEmphasisIcon = '#191919';
var TagHighlightDefaultBackground = '#D7F5F5';
var TagHighlightDefaultBorder = '#D7F5F5';
var TagHighlightDefaultForeground = '#00666D';
var TagHighlightDefaultIcon = '#00666D';
var TagHighlightEmphasisBackground = '#00838A';
var TagHighlightEmphasisBorder = '#00838A';
var TagHighlightEmphasisForeground = '#ffffff';
var TagHighlightEmphasisIcon = '#ffffff';
var TagInformationalSubduedBackground = '#ffffff';
var TagInformationalSubduedBorder = '#D6D6D6';
var TagInformationalSubduedForeground = '#767676';
var TagInformationalSubduedIcon = '#767676';
var TagNegativeSubduedBackground = '#ffffff';
var TagNegativeSubduedBorder = '#D6D6D6';
var TagNegativeSubduedForeground = '#B71000';
var TagNegativeSubduedIcon = '#B71000';
var TagPositiveSubduedBackground = '#ffffff';
var TagPositiveSubduedBorder = '#D6D6D6';
var TagPositiveSubduedForeground = '#00872F';
var TagPositiveSubduedIcon = '#00872F';
var TagWarningSubduedBackground = '#ffffff';
var TagWarningSubduedBorder = '#D6D6D6';
var TagWarningSubduedForeground = '#A16C00';
var TagWarningSubduedIcon = '#A16C00';
var TagHighlightSubduedBackground = '#ffffff';
var TagHighlightSubduedBorder = '#D6D6D6';
var TagHighlightSubduedForeground = '#00838A';
var TagHighlightSubduedIcon = '#00838A';
var TextAccentedPrimary = '#EB1700';
var TextAccentedSecondary = '#00838A';
var TextAction = '#EB1700';
var TextCallout = '#EB1700';
var TextDashpass = '#00838A';
var TextDisabled = '#B2B2B2';
var TextError = '#B71000';
var TextHighlight = '#00838A';
var TextLink = '#00838A';
var TextPositive = '#00872F';
var TextPrimary = '#191919';
var TextPrimaryOnDark = '#ffffff';
var TextSecondary = '#494949';
var TextSecondaryOnDark = '#D6D6D6';
var TextSelected = '#EB1700';
var TextTertiary = '#767676';
var TextTooltip = '#C4C4C4';
var TextWarning = '#A16C00';
var TimelineTrackBackgroundOff = '#E7E7E7';
var TimelineTrackBackgroundOn = '#191919';
var TimelineTrackForegroundOff = '#191919';
var TimelineTrackForegroundOn = '#ffffff';
var TimelineTrackShimmer = '#494949';
var ToastInformationalBackground = '#313131';
var ToastInformationalForeground = '#E7E7E7';
var ToastInformationalAction = '#ffffff';
var ToastInformationalActionPressed = '#B2B2B2';
var ToastInformationalActionHovered = '#D6D6D6';
var ToastInformationalActionDisabled = '#606060';
var ToggleBackgroundOn = '#191919';
var ToggleBackgroundOnDisabled = '#D6D6D6';
var ToggleBackgroundOff = '#ffffff';
var ToggleBackgroundOffDisabled = '#F7F7F7';
var ToggleBorderOn = '#191919';
var ToggleBorderOnDisabled = '#D6D6D6';
var ToggleBorderOff = '#191919';
var ToggleBorderOffDisabled = '#B2B2B2';
var ToggleForegroundOn = '#ffffff';
var ToggleForegroundOff = '#ffffff';
var ToggleForegroundOnDisabled = '#F7F7F7';
var ToggleForegroundOffDisabled = '#ffffff';
var ToggleBackgroundDisabled = '#D6D6D6';
var ToggleCheckmarkOn = '#ffffff';
var ToggleTrackBackgroundDisabled = '#F7F7F7';
var ToggleTrackBackgroundOff = '#E7E7E7';
var TooltipHighlightBackground = '#00838A';
var TooltipHighlightBackgroundHovered = '#00666D';
var TooltipHighlightBackgroundPressed = '#00494E';
var TooltipHighlightForeground = '#ffffff';
var TooltipHighlightForegroundHovered = '#ffffff';
var TooltipHighlightForegroundPressed = '#ffffff';
var TooltipInformationalBackground = '#313131';
var TooltipInformationalBackgroundHovered = '#494949';
var TooltipInformationalBackgroundPressed = '#606060';
var TooltipInformationalForeground = '#E7E7E7';
var TooltipInformationalForegroundHovered = '#D6D6D6';
var TooltipInformationalForegroundPressed = '#C4C4C4';
var WarningForeground = '#191919';
var WarningBackground = '#FEFF58';
var ColorSemanticsAll = {
  BackgroundElevated: BackgroundElevated,
  BackgroundOverlay: BackgroundOverlay,
  BackgroundPrimary: BackgroundPrimary,
  BackgroundPrimaryInverted: BackgroundPrimaryInverted,
  BackgroundSecondary: BackgroundSecondary,
  BackgroundSecondaryInverted: BackgroundSecondaryInverted,
  BackgroundSeparator: BackgroundSeparator,
  BackgroundTertiary: BackgroundTertiary,
  BannerDefaultBackground: BannerDefaultBackground,
  BannerDefaultForeground: BannerDefaultForeground,
  BannerDefaultIcon: BannerDefaultIcon,
  BannerHighlightBackground: BannerHighlightBackground,
  BannerHighlightDefaultBackground: BannerHighlightDefaultBackground,
  BannerHighlightDefaultForeground: BannerHighlightDefaultForeground,
  BannerHighlightDefaultIcon: BannerHighlightDefaultIcon,
  BannerHighlightEmphasisBackground: BannerHighlightEmphasisBackground,
  BannerHighlightEmphasisForeground: BannerHighlightEmphasisForeground,
  BannerHighlightEmphasisIcon: BannerHighlightEmphasisIcon,
  BannerHighlightForeground: BannerHighlightForeground,
  BannerHighlightIcon: BannerHighlightIcon,
  BannerHighlightSubduedBackground: BannerHighlightSubduedBackground,
  BannerHighlightSubduedBorder: BannerHighlightSubduedBorder,
  BannerHighlightSubduedDecorator: BannerHighlightSubduedDecorator,
  BannerHighlightSubduedForeground: BannerHighlightSubduedForeground,
  BannerHighlightSubduedIcon: BannerHighlightSubduedIcon,
  BannerHighlightSubduedIconBackground: BannerHighlightSubduedIconBackground,
  BannerInformationalBackground: BannerInformationalBackground,
  BannerInformationalDefaultBackground: BannerInformationalDefaultBackground,
  BannerInformationalDefaultForeground: BannerInformationalDefaultForeground,
  BannerInformationalDefaultIcon: BannerInformationalDefaultIcon,
  BannerInformationalEmphasisBackground: BannerInformationalEmphasisBackground,
  BannerInformationalEmphasisForeground: BannerInformationalEmphasisForeground,
  BannerInformationalEmphasisIcon: BannerInformationalEmphasisIcon,
  BannerInformationalForeground: BannerInformationalForeground,
  BannerInformationalIcon: BannerInformationalIcon,
  BannerInformationalSubduedBackground: BannerInformationalSubduedBackground,
  BannerInformationalSubduedBorder: BannerInformationalSubduedBorder,
  BannerInformationalSubduedDecorator: BannerInformationalSubduedDecorator,
  BannerInformationalSubduedForeground: BannerInformationalSubduedForeground,
  BannerInformationalSubduedIcon: BannerInformationalSubduedIcon,
  BannerInformationalSubduedIconBackground: BannerInformationalSubduedIconBackground,
  BannerNegativeBackground: BannerNegativeBackground,
  BannerNegativeDefaultBackground: BannerNegativeDefaultBackground,
  BannerNegativeDefaultForeground: BannerNegativeDefaultForeground,
  BannerNegativeDefaultIcon: BannerNegativeDefaultIcon,
  BannerNegativeEmphasisBackground: BannerNegativeEmphasisBackground,
  BannerNegativeEmphasisForeground: BannerNegativeEmphasisForeground,
  BannerNegativeEmphasisIcon: BannerNegativeEmphasisIcon,
  BannerNegativeForeground: BannerNegativeForeground,
  BannerNegativeIcon: BannerNegativeIcon,
  BannerNegativeSubduedBackground: BannerNegativeSubduedBackground,
  BannerNegativeSubduedBorder: BannerNegativeSubduedBorder,
  BannerNegativeSubduedDecorator: BannerNegativeSubduedDecorator,
  BannerNegativeSubduedForeground: BannerNegativeSubduedForeground,
  BannerNegativeSubduedIcon: BannerNegativeSubduedIcon,
  BannerNegativeSubduedIconBackground: BannerNegativeSubduedIconBackground,
  BannerPositiveBackground: BannerPositiveBackground,
  BannerPositiveDefaultBackground: BannerPositiveDefaultBackground,
  BannerPositiveDefaultForeground: BannerPositiveDefaultForeground,
  BannerPositiveDefaultIcon: BannerPositiveDefaultIcon,
  BannerPositiveEmphasisBackground: BannerPositiveEmphasisBackground,
  BannerPositiveEmphasisForeground: BannerPositiveEmphasisForeground,
  BannerPositiveEmphasisIcon: BannerPositiveEmphasisIcon,
  BannerPositiveForeground: BannerPositiveForeground,
  BannerPositiveIcon: BannerPositiveIcon,
  BannerPositiveSubduedBackground: BannerPositiveSubduedBackground,
  BannerPositiveSubduedBorder: BannerPositiveSubduedBorder,
  BannerPositiveSubduedDecorator: BannerPositiveSubduedDecorator,
  BannerPositiveSubduedForeground: BannerPositiveSubduedForeground,
  BannerPositiveSubduedIcon: BannerPositiveSubduedIcon,
  BannerPositiveSubduedIconBackground: BannerPositiveSubduedIconBackground,
  BannerWarningBackground: BannerWarningBackground,
  BannerWarningDefaultBackground: BannerWarningDefaultBackground,
  BannerWarningDefaultForeground: BannerWarningDefaultForeground,
  BannerWarningDefaultIcon: BannerWarningDefaultIcon,
  BannerWarningEmphasisBackground: BannerWarningEmphasisBackground,
  BannerWarningEmphasisForeground: BannerWarningEmphasisForeground,
  BannerWarningEmphasisIcon: BannerWarningEmphasisIcon,
  BannerWarningForeground: BannerWarningForeground,
  BannerWarningIcon: BannerWarningIcon,
  BannerWarningSubduedBackground: BannerWarningSubduedBackground,
  BannerWarningSubduedBorder: BannerWarningSubduedBorder,
  BannerWarningSubduedDecorator: BannerWarningSubduedDecorator,
  BannerWarningSubduedForeground: BannerWarningSubduedForeground,
  BannerWarningSubduedIcon: BannerWarningSubduedIcon,
  BannerWarningSubduedIconBackground: BannerWarningSubduedIconBackground,
  BorderError: BorderError,
  BorderErrorDisabled: BorderErrorDisabled,
  BorderFocus: BorderFocus,
  BorderPrimary: BorderPrimary,
  BorderSecondary: BorderSecondary,
  BreadcrumbText: BreadcrumbText,
  BreadcrumbTextDisabled: BreadcrumbTextDisabled,
  BreadcrumbTextHovered: BreadcrumbTextHovered,
  BreadcrumbTextPressed: BreadcrumbTextPressed,
  ButtonDefaultForeground: ButtonDefaultForeground,
  ButtonDefaultForegroundDisabled: ButtonDefaultForegroundDisabled,
  ButtonDefaultForegroundHovered: ButtonDefaultForegroundHovered,
  ButtonDefaultForegroundPressed: ButtonDefaultForegroundPressed,
  ButtonDefaultToggleForeground: ButtonDefaultToggleForeground,
  ButtonDefaultToggleForegroundDisabled: ButtonDefaultToggleForegroundDisabled,
  ButtonDefaultToggleForegroundHovered: ButtonDefaultToggleForegroundHovered,
  ButtonDefaultToggleForegroundOff: ButtonDefaultToggleForegroundOff,
  ButtonDefaultToggleForegroundOffDisabled: ButtonDefaultToggleForegroundOffDisabled,
  ButtonDefaultToggleForegroundOffHovered: ButtonDefaultToggleForegroundOffHovered,
  ButtonDefaultToggleForegroundOffPressed: ButtonDefaultToggleForegroundOffPressed,
  ButtonDefaultToggleForegroundPressed: ButtonDefaultToggleForegroundPressed,
  ButtonDestructiveBackground: ButtonDestructiveBackground,
  ButtonDestructiveBackgroundDisabled: ButtonDestructiveBackgroundDisabled,
  ButtonDestructiveBackgroundHovered: ButtonDestructiveBackgroundHovered,
  ButtonDestructiveBackgroundPressed: ButtonDestructiveBackgroundPressed,
  ButtonDestructiveForeground: ButtonDestructiveForeground,
  ButtonDestructiveForegroundDisabled: ButtonDestructiveForegroundDisabled,
  ButtonDestructiveForegroundHovered: ButtonDestructiveForegroundHovered,
  ButtonDestructiveForegroundPressed: ButtonDestructiveForegroundPressed,
  ButtonFabBackground: ButtonFabBackground,
  ButtonFabBackgroundDisabled: ButtonFabBackgroundDisabled,
  ButtonFabBackgroundHovered: ButtonFabBackgroundHovered,
  ButtonFabBackgroundPressed: ButtonFabBackgroundPressed,
  ButtonFabForeground: ButtonFabForeground,
  ButtonFabForegroundDisabled: ButtonFabForegroundDisabled,
  ButtonFabForegroundHovered: ButtonFabForegroundHovered,
  ButtonFabForegroundPressed: ButtonFabForegroundPressed,
  ButtonFlatPrimaryBackground: ButtonFlatPrimaryBackground,
  ButtonFlatPrimaryBackgroundDisabled: ButtonFlatPrimaryBackgroundDisabled,
  ButtonFlatPrimaryBackgroundHovered: ButtonFlatPrimaryBackgroundHovered,
  ButtonFlatPrimaryBackgroundPressed: ButtonFlatPrimaryBackgroundPressed,
  ButtonFlatPrimaryForeground: ButtonFlatPrimaryForeground,
  ButtonFlatPrimaryForegroundDisabled: ButtonFlatPrimaryForegroundDisabled,
  ButtonFlatPrimaryForegroundHovered: ButtonFlatPrimaryForegroundHovered,
  ButtonFlatPrimaryForegroundPressed: ButtonFlatPrimaryForegroundPressed,
  ButtonFlatSecondaryBackground: ButtonFlatSecondaryBackground,
  ButtonFlatSecondaryBackgroundDisabled: ButtonFlatSecondaryBackgroundDisabled,
  ButtonFlatSecondaryBackgroundHovered: ButtonFlatSecondaryBackgroundHovered,
  ButtonFlatSecondaryBackgroundPressed: ButtonFlatSecondaryBackgroundPressed,
  ButtonFlatSecondaryForeground: ButtonFlatSecondaryForeground,
  ButtonFlatSecondaryForegroundDisabled: ButtonFlatSecondaryForegroundDisabled,
  ButtonFlatSecondaryForegroundHovered: ButtonFlatSecondaryForegroundHovered,
  ButtonFlatSecondaryForegroundPressed: ButtonFlatSecondaryForegroundPressed,
  ButtonFloatingToggleGroupBackgroundColorOff: ButtonFloatingToggleGroupBackgroundColorOff,
  ButtonLinkForeground: ButtonLinkForeground,
  ButtonLinkForegroundDisabled: ButtonLinkForegroundDisabled,
  ButtonLinkForegroundHovered: ButtonLinkForegroundHovered,
  ButtonLinkForegroundPressed: ButtonLinkForegroundPressed,
  ButtonPlainBackground: ButtonPlainBackground,
  ButtonPlainBackgroundDisabled: ButtonPlainBackgroundDisabled,
  ButtonPlainBackgroundHovered: ButtonPlainBackgroundHovered,
  ButtonPlainBackgroundPressed: ButtonPlainBackgroundPressed,
  ButtonPlainForeground: ButtonPlainForeground,
  ButtonPlainForegroundDisabled: ButtonPlainForegroundDisabled,
  ButtonPlainForegroundHovered: ButtonPlainForegroundHovered,
  ButtonPlainForegroundPressed: ButtonPlainForegroundPressed,
  ButtonPlainToggleBackground: ButtonPlainToggleBackground,
  ButtonPlainToggleBackgroundDisabled: ButtonPlainToggleBackgroundDisabled,
  ButtonPlainToggleBackgroundHovered: ButtonPlainToggleBackgroundHovered,
  ButtonPlainToggleBackgroundOff: ButtonPlainToggleBackgroundOff,
  ButtonPlainToggleBackgroundOffDisabled: ButtonPlainToggleBackgroundOffDisabled,
  ButtonPlainToggleBackgroundOffHovered: ButtonPlainToggleBackgroundOffHovered,
  ButtonPlainToggleBackgroundOffPressed: ButtonPlainToggleBackgroundOffPressed,
  ButtonPlainToggleBackgroundPressed: ButtonPlainToggleBackgroundPressed,
  ButtonPlainToggleForeground: ButtonPlainToggleForeground,
  ButtonPlainToggleForegroundDisabled: ButtonPlainToggleForegroundDisabled,
  ButtonPlainToggleForegroundHovered: ButtonPlainToggleForegroundHovered,
  ButtonPlainToggleForegroundOff: ButtonPlainToggleForegroundOff,
  ButtonPlainToggleForegroundOffDisabled: ButtonPlainToggleForegroundOffDisabled,
  ButtonPlainToggleForegroundOffHovered: ButtonPlainToggleForegroundOffHovered,
  ButtonPlainToggleForegroundOffPressed: ButtonPlainToggleForegroundOffPressed,
  ButtonPlainToggleForegroundPressed: ButtonPlainToggleForegroundPressed,
  ButtonPrimaryBackground: ButtonPrimaryBackground,
  ButtonPrimaryBackgroundDisabled: ButtonPrimaryBackgroundDisabled,
  ButtonPrimaryBackgroundHovered: ButtonPrimaryBackgroundHovered,
  ButtonPrimaryBackgroundPressed: ButtonPrimaryBackgroundPressed,
  ButtonPrimaryForeground: ButtonPrimaryForeground,
  ButtonPrimaryForegroundDisabled: ButtonPrimaryForegroundDisabled,
  ButtonPrimaryForegroundHovered: ButtonPrimaryForegroundHovered,
  ButtonPrimaryForegroundPressed: ButtonPrimaryForegroundPressed,
  ButtonPrimaryToggleBackground: ButtonPrimaryToggleBackground,
  ButtonPrimaryToggleBackgroundDisabled: ButtonPrimaryToggleBackgroundDisabled,
  ButtonPrimaryToggleBackgroundHovered: ButtonPrimaryToggleBackgroundHovered,
  ButtonPrimaryToggleBackgroundOff: ButtonPrimaryToggleBackgroundOff,
  ButtonPrimaryToggleBackgroundOffDisabled: ButtonPrimaryToggleBackgroundOffDisabled,
  ButtonPrimaryToggleBackgroundOffHovered: ButtonPrimaryToggleBackgroundOffHovered,
  ButtonPrimaryToggleBackgroundOffPressed: ButtonPrimaryToggleBackgroundOffPressed,
  ButtonPrimaryToggleBackgroundPressed: ButtonPrimaryToggleBackgroundPressed,
  ButtonPrimaryToggleBorderOff: ButtonPrimaryToggleBorderOff,
  ButtonPrimaryToggleBorderOffDisabled: ButtonPrimaryToggleBorderOffDisabled,
  ButtonPrimaryToggleBorderOffHovered: ButtonPrimaryToggleBorderOffHovered,
  ButtonPrimaryToggleBorderOffPressed: ButtonPrimaryToggleBorderOffPressed,
  ButtonPrimaryToggleBorderOn: ButtonPrimaryToggleBorderOn,
  ButtonPrimaryToggleBorderOnDisabled: ButtonPrimaryToggleBorderOnDisabled,
  ButtonPrimaryToggleBorderOnHovered: ButtonPrimaryToggleBorderOnHovered,
  ButtonPrimaryToggleBorderOnPressed: ButtonPrimaryToggleBorderOnPressed,
  ButtonPrimaryToggleForeground: ButtonPrimaryToggleForeground,
  ButtonPrimaryToggleForegroundDisabled: ButtonPrimaryToggleForegroundDisabled,
  ButtonPrimaryToggleForegroundHovered: ButtonPrimaryToggleForegroundHovered,
  ButtonPrimaryToggleForegroundOff: ButtonPrimaryToggleForegroundOff,
  ButtonPrimaryToggleForegroundOffDisabled: ButtonPrimaryToggleForegroundOffDisabled,
  ButtonPrimaryToggleForegroundOffHovered: ButtonPrimaryToggleForegroundOffHovered,
  ButtonPrimaryToggleForegroundOffPressed: ButtonPrimaryToggleForegroundOffPressed,
  ButtonPrimaryToggleForegroundPressed: ButtonPrimaryToggleForegroundPressed,
  ButtonPrimaryToggleGroupBackgroundOff: ButtonPrimaryToggleGroupBackgroundOff,
  ButtonPrimaryToggleGroupBackgroundOffDisabled: ButtonPrimaryToggleGroupBackgroundOffDisabled,
  ButtonPrimaryToggleGroupBackgroundOffHovered: ButtonPrimaryToggleGroupBackgroundOffHovered,
  ButtonPrimaryToggleGroupBackgroundOffPressed: ButtonPrimaryToggleGroupBackgroundOffPressed,
  ButtonPrimaryToggleGroupBackgroundOn: ButtonPrimaryToggleGroupBackgroundOn,
  ButtonPrimaryToggleGroupBackgroundOnDisabled: ButtonPrimaryToggleGroupBackgroundOnDisabled,
  ButtonPrimaryToggleGroupBackgroundOnHovered: ButtonPrimaryToggleGroupBackgroundOnHovered,
  ButtonPrimaryToggleGroupBackgroundOnPressed: ButtonPrimaryToggleGroupBackgroundOnPressed,
  ButtonPrimaryToggleGroupBorderOff: ButtonPrimaryToggleGroupBorderOff,
  ButtonPrimaryToggleGroupBorderOffDisabled: ButtonPrimaryToggleGroupBorderOffDisabled,
  ButtonPrimaryToggleGroupBorderOffHovered: ButtonPrimaryToggleGroupBorderOffHovered,
  ButtonPrimaryToggleGroupBorderOffPressed: ButtonPrimaryToggleGroupBorderOffPressed,
  ButtonPrimaryToggleGroupBorderOn: ButtonPrimaryToggleGroupBorderOn,
  ButtonPrimaryToggleGroupBorderOnDisabled: ButtonPrimaryToggleGroupBorderOnDisabled,
  ButtonPrimaryToggleGroupBorderOnHovered: ButtonPrimaryToggleGroupBorderOnHovered,
  ButtonPrimaryToggleGroupBorderOnPressed: ButtonPrimaryToggleGroupBorderOnPressed,
  ButtonPrimaryToggleGroupForegroundOff: ButtonPrimaryToggleGroupForegroundOff,
  ButtonPrimaryToggleGroupForegroundOffDisabled: ButtonPrimaryToggleGroupForegroundOffDisabled,
  ButtonPrimaryToggleGroupForegroundOffHovered: ButtonPrimaryToggleGroupForegroundOffHovered,
  ButtonPrimaryToggleGroupForegroundOffPressed: ButtonPrimaryToggleGroupForegroundOffPressed,
  ButtonPrimaryToggleGroupForegroundOn: ButtonPrimaryToggleGroupForegroundOn,
  ButtonPrimaryToggleGroupForegroundOnDisabled: ButtonPrimaryToggleGroupForegroundOnDisabled,
  ButtonPrimaryToggleGroupForegroundOnHovered: ButtonPrimaryToggleGroupForegroundOnHovered,
  ButtonPrimaryToggleGroupForegroundOnPressed: ButtonPrimaryToggleGroupForegroundOnPressed,
  ButtonSecondaryBackground: ButtonSecondaryBackground,
  ButtonSecondaryBackgroundDisabled: ButtonSecondaryBackgroundDisabled,
  ButtonSecondaryBackgroundHovered: ButtonSecondaryBackgroundHovered,
  ButtonSecondaryBackgroundPressed: ButtonSecondaryBackgroundPressed,
  ButtonSecondaryForeground: ButtonSecondaryForeground,
  ButtonSecondaryForegroundDisabled: ButtonSecondaryForegroundDisabled,
  ButtonSecondaryForegroundHovered: ButtonSecondaryForegroundHovered,
  ButtonSecondaryForegroundPressed: ButtonSecondaryForegroundPressed,
  ButtonSecondaryToggleBackground: ButtonSecondaryToggleBackground,
  ButtonSecondaryToggleBackgroundDisabled: ButtonSecondaryToggleBackgroundDisabled,
  ButtonSecondaryToggleBackgroundHovered: ButtonSecondaryToggleBackgroundHovered,
  ButtonSecondaryToggleBackgroundOff: ButtonSecondaryToggleBackgroundOff,
  ButtonSecondaryToggleBackgroundOffDisabled: ButtonSecondaryToggleBackgroundOffDisabled,
  ButtonSecondaryToggleBackgroundOffHovered: ButtonSecondaryToggleBackgroundOffHovered,
  ButtonSecondaryToggleBackgroundOffPressed: ButtonSecondaryToggleBackgroundOffPressed,
  ButtonSecondaryToggleBackgroundPressed: ButtonSecondaryToggleBackgroundPressed,
  ButtonSecondaryToggleBorderOff: ButtonSecondaryToggleBorderOff,
  ButtonSecondaryToggleBorderOffDisabled: ButtonSecondaryToggleBorderOffDisabled,
  ButtonSecondaryToggleBorderOffHovered: ButtonSecondaryToggleBorderOffHovered,
  ButtonSecondaryToggleBorderOffPressed: ButtonSecondaryToggleBorderOffPressed,
  ButtonSecondaryToggleBorderOn: ButtonSecondaryToggleBorderOn,
  ButtonSecondaryToggleBorderOnDisabled: ButtonSecondaryToggleBorderOnDisabled,
  ButtonSecondaryToggleBorderOnHovered: ButtonSecondaryToggleBorderOnHovered,
  ButtonSecondaryToggleBorderOnPressed: ButtonSecondaryToggleBorderOnPressed,
  ButtonSecondaryToggleForeground: ButtonSecondaryToggleForeground,
  ButtonSecondaryToggleForegroundDisabled: ButtonSecondaryToggleForegroundDisabled,
  ButtonSecondaryToggleForegroundHovered: ButtonSecondaryToggleForegroundHovered,
  ButtonSecondaryToggleForegroundOff: ButtonSecondaryToggleForegroundOff,
  ButtonSecondaryToggleForegroundOffDisabled: ButtonSecondaryToggleForegroundOffDisabled,
  ButtonSecondaryToggleForegroundOffHovered: ButtonSecondaryToggleForegroundOffHovered,
  ButtonSecondaryToggleForegroundOffPressed: ButtonSecondaryToggleForegroundOffPressed,
  ButtonSecondaryToggleForegroundPressed: ButtonSecondaryToggleForegroundPressed,
  ButtonSecondaryToggleGroupBackgroundOff: ButtonSecondaryToggleGroupBackgroundOff,
  ButtonSecondaryToggleGroupBackgroundOffDisabled: ButtonSecondaryToggleGroupBackgroundOffDisabled,
  ButtonSecondaryToggleGroupBackgroundOffHovered: ButtonSecondaryToggleGroupBackgroundOffHovered,
  ButtonSecondaryToggleGroupBackgroundOffPressed: ButtonSecondaryToggleGroupBackgroundOffPressed,
  ButtonSecondaryToggleGroupBackgroundOn: ButtonSecondaryToggleGroupBackgroundOn,
  ButtonSecondaryToggleGroupBackgroundOnDisabled: ButtonSecondaryToggleGroupBackgroundOnDisabled,
  ButtonSecondaryToggleGroupBackgroundOnHovered: ButtonSecondaryToggleGroupBackgroundOnHovered,
  ButtonSecondaryToggleGroupBackgroundOnPressed: ButtonSecondaryToggleGroupBackgroundOnPressed,
  ButtonSecondaryToggleGroupBorderOff: ButtonSecondaryToggleGroupBorderOff,
  ButtonSecondaryToggleGroupBorderOffDisabled: ButtonSecondaryToggleGroupBorderOffDisabled,
  ButtonSecondaryToggleGroupBorderOffHovered: ButtonSecondaryToggleGroupBorderOffHovered,
  ButtonSecondaryToggleGroupBorderOffPressed: ButtonSecondaryToggleGroupBorderOffPressed,
  ButtonSecondaryToggleGroupBorderOn: ButtonSecondaryToggleGroupBorderOn,
  ButtonSecondaryToggleGroupBorderOnDisabled: ButtonSecondaryToggleGroupBorderOnDisabled,
  ButtonSecondaryToggleGroupBorderOnHovered: ButtonSecondaryToggleGroupBorderOnHovered,
  ButtonSecondaryToggleGroupBorderOnPressed: ButtonSecondaryToggleGroupBorderOnPressed,
  ButtonSecondaryToggleGroupForegroundOff: ButtonSecondaryToggleGroupForegroundOff,
  ButtonSecondaryToggleGroupForegroundOffDisabled: ButtonSecondaryToggleGroupForegroundOffDisabled,
  ButtonSecondaryToggleGroupForegroundOffHovered: ButtonSecondaryToggleGroupForegroundOffHovered,
  ButtonSecondaryToggleGroupForegroundOffPressed: ButtonSecondaryToggleGroupForegroundOffPressed,
  ButtonSecondaryToggleGroupForegroundOn: ButtonSecondaryToggleGroupForegroundOn,
  ButtonSecondaryToggleGroupForegroundOnDisabled: ButtonSecondaryToggleGroupForegroundOnDisabled,
  ButtonSecondaryToggleGroupForegroundOnHovered: ButtonSecondaryToggleGroupForegroundOnHovered,
  ButtonSecondaryToggleGroupForegroundOnPressed: ButtonSecondaryToggleGroupForegroundOnPressed,
  ButtonTabBackgroundOffDefault: ButtonTabBackgroundOffDefault,
  ButtonTabBackgroundOffDisabled: ButtonTabBackgroundOffDisabled,
  ButtonTabBackgroundOffHovered: ButtonTabBackgroundOffHovered,
  ButtonTabBackgroundOffPressed: ButtonTabBackgroundOffPressed,
  ButtonTabBackgroundOnDefault: ButtonTabBackgroundOnDefault,
  ButtonTabBackgroundOnDisabled: ButtonTabBackgroundOnDisabled,
  ButtonTabBackgroundOnHovered: ButtonTabBackgroundOnHovered,
  ButtonTabBackgroundOnPressed: ButtonTabBackgroundOnPressed,
  ButtonTabForegroundOffDefault: ButtonTabForegroundOffDefault,
  ButtonTabForegroundOffDisabled: ButtonTabForegroundOffDisabled,
  ButtonTabForegroundOffHovered: ButtonTabForegroundOffHovered,
  ButtonTabForegroundOffPressed: ButtonTabForegroundOffPressed,
  ButtonTabForegroundOnDefault: ButtonTabForegroundOnDefault,
  ButtonTabForegroundOnDisabled: ButtonTabForegroundOnDisabled,
  ButtonTabForegroundOnHovered: ButtonTabForegroundOnHovered,
  ButtonTabForegroundOnPressed: ButtonTabForegroundOnPressed,
  ButtonTertiaryBackground: ButtonTertiaryBackground,
  ButtonTertiaryBackgroundDisabled: ButtonTertiaryBackgroundDisabled,
  ButtonTertiaryBackgroundHovered: ButtonTertiaryBackgroundHovered,
  ButtonTertiaryBackgroundPressed: ButtonTertiaryBackgroundPressed,
  ButtonTertiaryBorder: ButtonTertiaryBorder,
  ButtonTertiaryBorderDisabled: ButtonTertiaryBorderDisabled,
  ButtonTertiaryBorderHovered: ButtonTertiaryBorderHovered,
  ButtonTertiaryBorderPressed: ButtonTertiaryBorderPressed,
  ButtonTertiaryForeground: ButtonTertiaryForeground,
  ButtonTertiaryForegroundDisabled: ButtonTertiaryForegroundDisabled,
  ButtonTertiaryForegroundHovered: ButtonTertiaryForegroundHovered,
  ButtonTertiaryForegroundPressed: ButtonTertiaryForegroundPressed,
  ButtonTertiaryToggleBackground: ButtonTertiaryToggleBackground,
  ButtonTertiaryToggleBackgroundDisabled: ButtonTertiaryToggleBackgroundDisabled,
  ButtonTertiaryToggleBackgroundHovered: ButtonTertiaryToggleBackgroundHovered,
  ButtonTertiaryToggleBackgroundOff: ButtonTertiaryToggleBackgroundOff,
  ButtonTertiaryToggleBackgroundOffDisabled: ButtonTertiaryToggleBackgroundOffDisabled,
  ButtonTertiaryToggleBackgroundOffHovered: ButtonTertiaryToggleBackgroundOffHovered,
  ButtonTertiaryToggleBackgroundOffPressed: ButtonTertiaryToggleBackgroundOffPressed,
  ButtonTertiaryToggleBackgroundPressed: ButtonTertiaryToggleBackgroundPressed,
  ButtonTertiaryToggleBorderOff: ButtonTertiaryToggleBorderOff,
  ButtonTertiaryToggleBorderOffDisabled: ButtonTertiaryToggleBorderOffDisabled,
  ButtonTertiaryToggleBorderOffHovered: ButtonTertiaryToggleBorderOffHovered,
  ButtonTertiaryToggleBorderOffPressed: ButtonTertiaryToggleBorderOffPressed,
  ButtonTertiaryToggleBorderOn: ButtonTertiaryToggleBorderOn,
  ButtonTertiaryToggleBorderOnDisabled: ButtonTertiaryToggleBorderOnDisabled,
  ButtonTertiaryToggleBorderOnHovered: ButtonTertiaryToggleBorderOnHovered,
  ButtonTertiaryToggleBorderOnPressed: ButtonTertiaryToggleBorderOnPressed,
  ButtonTertiaryToggleForeground: ButtonTertiaryToggleForeground,
  ButtonTertiaryToggleForegroundDisabled: ButtonTertiaryToggleForegroundDisabled,
  ButtonTertiaryToggleForegroundHovered: ButtonTertiaryToggleForegroundHovered,
  ButtonTertiaryToggleForegroundOff: ButtonTertiaryToggleForegroundOff,
  ButtonTertiaryToggleForegroundOffDisabled: ButtonTertiaryToggleForegroundOffDisabled,
  ButtonTertiaryToggleForegroundOffHovered: ButtonTertiaryToggleForegroundOffHovered,
  ButtonTertiaryToggleForegroundOffPressed: ButtonTertiaryToggleForegroundOffPressed,
  ButtonTertiaryToggleForegroundPressed: ButtonTertiaryToggleForegroundPressed,
  ButtonTertiaryToggleGroupBackgroundOff: ButtonTertiaryToggleGroupBackgroundOff,
  ButtonTertiaryToggleGroupBackgroundOffDisabled: ButtonTertiaryToggleGroupBackgroundOffDisabled,
  ButtonTertiaryToggleGroupBackgroundOffHovered: ButtonTertiaryToggleGroupBackgroundOffHovered,
  ButtonTertiaryToggleGroupBackgroundOffPressed: ButtonTertiaryToggleGroupBackgroundOffPressed,
  ButtonTertiaryToggleGroupBackgroundOn: ButtonTertiaryToggleGroupBackgroundOn,
  ButtonTertiaryToggleGroupBackgroundOnDisabled: ButtonTertiaryToggleGroupBackgroundOnDisabled,
  ButtonTertiaryToggleGroupBackgroundOnHovered: ButtonTertiaryToggleGroupBackgroundOnHovered,
  ButtonTertiaryToggleGroupBackgroundOnPressed: ButtonTertiaryToggleGroupBackgroundOnPressed,
  ButtonTertiaryToggleGroupBorderOff: ButtonTertiaryToggleGroupBorderOff,
  ButtonTertiaryToggleGroupBorderOffDisabled: ButtonTertiaryToggleGroupBorderOffDisabled,
  ButtonTertiaryToggleGroupBorderOffHovered: ButtonTertiaryToggleGroupBorderOffHovered,
  ButtonTertiaryToggleGroupBorderOffPressed: ButtonTertiaryToggleGroupBorderOffPressed,
  ButtonTertiaryToggleGroupBorderOn: ButtonTertiaryToggleGroupBorderOn,
  ButtonTertiaryToggleGroupBorderOnDisabled: ButtonTertiaryToggleGroupBorderOnDisabled,
  ButtonTertiaryToggleGroupBorderOnHovered: ButtonTertiaryToggleGroupBorderOnHovered,
  ButtonTertiaryToggleGroupBorderOnPressed: ButtonTertiaryToggleGroupBorderOnPressed,
  ButtonTertiaryToggleGroupForegroundOff: ButtonTertiaryToggleGroupForegroundOff,
  ButtonTertiaryToggleGroupForegroundOffDisabled: ButtonTertiaryToggleGroupForegroundOffDisabled,
  ButtonTertiaryToggleGroupForegroundOffHovered: ButtonTertiaryToggleGroupForegroundOffHovered,
  ButtonTertiaryToggleGroupForegroundOffPressed: ButtonTertiaryToggleGroupForegroundOffPressed,
  ButtonTertiaryToggleGroupForegroundOn: ButtonTertiaryToggleGroupForegroundOn,
  ButtonTertiaryToggleGroupForegroundOnDisabled: ButtonTertiaryToggleGroupForegroundOnDisabled,
  ButtonTertiaryToggleGroupForegroundOnHovered: ButtonTertiaryToggleGroupForegroundOnHovered,
  ButtonTertiaryToggleGroupForegroundOnPressed: ButtonTertiaryToggleGroupForegroundOnPressed,
  CardBackgroundDefault: CardBackgroundDefault,
  CardBackgroundDisabled: CardBackgroundDisabled,
  CardBackgroundHovered: CardBackgroundHovered,
  CardBackgroundPressed: CardBackgroundPressed,
  CardBodyDefault: CardBodyDefault,
  CardBodyDisabled: CardBodyDisabled,
  CardBodyHovered: CardBodyHovered,
  CardBodyPressed: CardBodyPressed,
  CardBorderSelectedDefault: CardBorderSelectedDefault,
  CardBorderSelectedDisabled: CardBorderSelectedDisabled,
  CardBorderSelectedError: CardBorderSelectedError,
  CardBorderSelectedErrorDisabled: CardBorderSelectedErrorDisabled,
  CardBorderSelectedHovered: CardBorderSelectedHovered,
  CardBorderSelectedPressed: CardBorderSelectedPressed,
  CardBorderUnselectedDefault: CardBorderUnselectedDefault,
  CardBorderUnselectedDisabled: CardBorderUnselectedDisabled,
  CardBorderUnselectedError: CardBorderUnselectedError,
  CardBorderUnselectedErrorDisabled: CardBorderUnselectedErrorDisabled,
  CardBorderUnselectedHovered: CardBorderUnselectedHovered,
  CardBorderUnselectedPressed: CardBorderUnselectedPressed,
  CardTitleDefault: CardTitleDefault,
  CardTitleDisabled: CardTitleDisabled,
  CardTitleHovered: CardTitleHovered,
  CardTitlePressed: CardTitlePressed,
  ChatIncomingBackground: ChatIncomingBackground,
  ChatIncomingForeground: ChatIncomingForeground,
  ChatOutgoingBackground: ChatOutgoingBackground,
  ChatOutgoingForeground: ChatOutgoingForeground,
  DatePickerDateBorderSelected: DatePickerDateBorderSelected,
  DatePickerDateBorderSelectedDisabled: DatePickerDateBorderSelectedDisabled,
  DatePickerDateBorderSelectedHovered: DatePickerDateBorderSelectedHovered,
  DatePickerDateBorderSelectedPressed: DatePickerDateBorderSelectedPressed,
  DatePickerDateBorderUnselected: DatePickerDateBorderUnselected,
  DatePickerDateBorderUnselectedDisabled: DatePickerDateBorderUnselectedDisabled,
  DatePickerDateBorderUnselectedHovered: DatePickerDateBorderUnselectedHovered,
  DatePickerDateBorderUnselectedPressed: DatePickerDateBorderUnselectedPressed,
  DatePickerDateForegroundSelected: DatePickerDateForegroundSelected,
  DatePickerDateForegroundSelectedDisabled: DatePickerDateForegroundSelectedDisabled,
  DatePickerDateForegroundSelectedHovered: DatePickerDateForegroundSelectedHovered,
  DatePickerDateForegroundSelectedPressed: DatePickerDateForegroundSelectedPressed,
  DatePickerDateForegroundUnselected: DatePickerDateForegroundUnselected,
  DatePickerDateForegroundUnselectedDisabled: DatePickerDateForegroundUnselectedDisabled,
  DatePickerDateForegroundUnselectedHovered: DatePickerDateForegroundUnselectedHovered,
  DatePickerDateForegroundUnselectedPressed: DatePickerDateForegroundUnselectedPressed,
  DatePickerDateSelectedBackground: DatePickerDateSelectedBackground,
  DatePickerDateSelectedBackgroundDisabled: DatePickerDateSelectedBackgroundDisabled,
  DatePickerDateSelectedBackgroundHovered: DatePickerDateSelectedBackgroundHovered,
  DatePickerDateSelectedBackgroundPressed: DatePickerDateSelectedBackgroundPressed,
  DatePickerDateSelectedIndicatorDisabled: DatePickerDateSelectedIndicatorDisabled,
  DatePickerDateSelectedIndicatorPrimary: DatePickerDateSelectedIndicatorPrimary,
  DatePickerDateSelectedIndicatorSecondary: DatePickerDateSelectedIndicatorSecondary,
  DatePickerDateUnselectedBackground: DatePickerDateUnselectedBackground,
  DatePickerDateUnselectedBackgroundDisabled: DatePickerDateUnselectedBackgroundDisabled,
  DatePickerDateUnselectedBackgroundHovered: DatePickerDateUnselectedBackgroundHovered,
  DatePickerDateUnselectedBackgroundPressed: DatePickerDateUnselectedBackgroundPressed,
  DatePickerDateUnselectedIndicatorDisabled: DatePickerDateUnselectedIndicatorDisabled,
  DatePickerDateUnselectedIndicatorPrimary: DatePickerDateUnselectedIndicatorPrimary,
  DatePickerDateUnselectedIndicatorSecondary: DatePickerDateUnselectedIndicatorSecondary,
  DatePickerRangeBorderSelected: DatePickerRangeBorderSelected,
  DatePickerRangeBorderSelectedDisabled: DatePickerRangeBorderSelectedDisabled,
  DatePickerRangeBorderSelectedHovered: DatePickerRangeBorderSelectedHovered,
  DatePickerRangeBorderSelectedPressed: DatePickerRangeBorderSelectedPressed,
  DatePickerRangeBorderUnselected: DatePickerRangeBorderUnselected,
  DatePickerRangeBorderUnselectedDisabled: DatePickerRangeBorderUnselectedDisabled,
  DatePickerRangeBorderUnselectedHovered: DatePickerRangeBorderUnselectedHovered,
  DatePickerRangeBorderUnselectedPressed: DatePickerRangeBorderUnselectedPressed,
  DatePickerRangeForegroundSelected: DatePickerRangeForegroundSelected,
  DatePickerRangeForegroundSelectedDisabled: DatePickerRangeForegroundSelectedDisabled,
  DatePickerRangeForegroundSelectedHovered: DatePickerRangeForegroundSelectedHovered,
  DatePickerRangeForegroundSelectedPressed: DatePickerRangeForegroundSelectedPressed,
  DatePickerRangeForegroundUnselected: DatePickerRangeForegroundUnselected,
  DatePickerRangeForegroundUnselectedDisabled: DatePickerRangeForegroundUnselectedDisabled,
  DatePickerRangeForegroundUnselectedHovered: DatePickerRangeForegroundUnselectedHovered,
  DatePickerRangeForegroundUnselectedPressed: DatePickerRangeForegroundUnselectedPressed,
  DatePickerRangeSelectedBackground: DatePickerRangeSelectedBackground,
  DatePickerRangeSelectedBackgroundDisabled: DatePickerRangeSelectedBackgroundDisabled,
  DatePickerRangeSelectedBackgroundHovered: DatePickerRangeSelectedBackgroundHovered,
  DatePickerRangeSelectedBackgroundPressed: DatePickerRangeSelectedBackgroundPressed,
  DatePickerRangeSelectedIndicatorDisabled: DatePickerRangeSelectedIndicatorDisabled,
  DatePickerRangeSelectedIndicatorPrimary: DatePickerRangeSelectedIndicatorPrimary,
  DatePickerRangeSelectedIndicatorSecondary: DatePickerRangeSelectedIndicatorSecondary,
  DatePickerRangeUnselectedBackground: DatePickerRangeUnselectedBackground,
  DatePickerRangeUnselectedBackgroundDisabled: DatePickerRangeUnselectedBackgroundDisabled,
  DatePickerRangeUnselectedBackgroundHovered: DatePickerRangeUnselectedBackgroundHovered,
  DatePickerRangeUnselectedBackgroundPressed: DatePickerRangeUnselectedBackgroundPressed,
  DatePickerTodayBorderSelected: DatePickerTodayBorderSelected,
  DiagonalDefaultOverlay: DiagonalDefaultOverlay,
  FieldsBackgroundActive: FieldsBackgroundActive,
  FieldsBackgroundDisabled: FieldsBackgroundDisabled,
  FieldsBackgroundError: FieldsBackgroundError,
  FieldsBackgroundInactive: FieldsBackgroundInactive,
  FieldsBorderActive: FieldsBorderActive,
  FieldsBorderDisabled: FieldsBorderDisabled,
  FieldsBorderError: FieldsBorderError,
  FieldsBorderInactive: FieldsBorderInactive,
  FieldsForegroundActive: FieldsForegroundActive,
  FieldsForegroundDisabled: FieldsForegroundDisabled,
  FieldsForegroundError: FieldsForegroundError,
  FieldsForegroundInactive: FieldsForegroundInactive,
  FieldsForegroundPlaceholder: FieldsForegroundPlaceholder,
  FieldsIconDropdown: FieldsIconDropdown,
  FieldsIconSearch: FieldsIconSearch,
  FieldsInputBackground: FieldsInputBackground,
  FieldsInputBackgroundDisabled: FieldsInputBackgroundDisabled,
  FieldsInputBorder: FieldsInputBorder,
  FieldsInputBorderError: FieldsInputBorderError,
  GlobalPrimary: GlobalPrimary,
  GlobalSecondary: GlobalSecondary,
  ListCellContainerBackgroundDefault: ListCellContainerBackgroundDefault,
  ListCellContainerBackgroundHovered: ListCellContainerBackgroundHovered,
  ListCellContainerBackgroundPressed: ListCellContainerBackgroundPressed,
  ListCellContainerBackgroundUnread: ListCellContainerBackgroundUnread,
  ListCellContainerBackgroundUnreadHovered: ListCellContainerBackgroundUnreadHovered,
  ListCellContainerBackgroundUnreadPressed: ListCellContainerBackgroundUnreadPressed,
  ListCellIconToggledOff: ListCellIconToggledOff,
  ListCellIconToggledOn: ListCellIconToggledOn,
  LoadingDefault: LoadingDefault,
  MapCurrentLocationBackgroundDefault: MapCurrentLocationBackgroundDefault,
  MapCurrentLocationBackgroundOverlay: MapCurrentLocationBackgroundOverlay,
  MapCurrentLocationBorder: MapCurrentLocationBorder,
  MapDasherBackground: MapDasherBackground,
  MapDasherBorder: MapDasherBorder,
  MapDasherForeground: MapDasherForeground,
  MapPinSelectedBackgroundDefault: MapPinSelectedBackgroundDefault,
  MapPinSelectedBackgroundDisabled: MapPinSelectedBackgroundDisabled,
  MapPinSelectedBorderDefault: MapPinSelectedBorderDefault,
  MapPinSelectedBorderDisabled: MapPinSelectedBorderDisabled,
  MapPinSelectedForegroundDefault: MapPinSelectedForegroundDefault,
  MapPinSelectedForegroundDisabled: MapPinSelectedForegroundDisabled,
  MapPinUnselectedBackgroundDefault: MapPinUnselectedBackgroundDefault,
  MapPinUnselectedBackgroundDisabled: MapPinUnselectedBackgroundDisabled,
  MapPinUnselectedBorderDefault: MapPinUnselectedBorderDefault,
  MapPinUnselectedBorderDisabled: MapPinUnselectedBorderDisabled,
  MapPinUnselectedForegroundAlcohol: MapPinUnselectedForegroundAlcohol,
  MapPinUnselectedForegroundCoffee: MapPinUnselectedForegroundCoffee,
  MapPinUnselectedForegroundDefault: MapPinUnselectedForegroundDefault,
  MapPinUnselectedForegroundDisabled: MapPinUnselectedForegroundDisabled,
  MapPinUnselectedForegroundFood: MapPinUnselectedForegroundFood,
  MapPinUnselectedForegroundGroceries: MapPinUnselectedForegroundGroceries,
  MapRoutelineBackgroundDefault: MapRoutelineBackgroundDefault,
  MapRoutelineBorder: MapRoutelineBorder,
  MapRoutelineNodeBackgroundDefault: MapRoutelineNodeBackgroundDefault,
  MapRoutelineNodeBorder: MapRoutelineNodeBorder,
  MenuItemBackground: MenuItemBackground,
  MenuItemBackgroundDisabled: MenuItemBackgroundDisabled,
  MenuItemBackgroundHovered: MenuItemBackgroundHovered,
  MenuItemBackgroundPressed: MenuItemBackgroundPressed,
  MenuItemForeground: MenuItemForeground,
  MenuItemForegroundDisabled: MenuItemForegroundDisabled,
  MenuItemForegroundHovered: MenuItemForegroundHovered,
  MenuItemForegroundPressed: MenuItemForegroundPressed,
  ModalBackground: ModalBackground,
  OverlayBackgroundDefault: OverlayBackgroundDefault,
  OverlayBackgroundLoading: OverlayBackgroundLoading,
  OverlayLoadingDefault: OverlayLoadingDefault,
  PageBackgroundPrimary: PageBackgroundPrimary,
  PageBackgroundSecondary: PageBackgroundSecondary,
  PageBackgroundTertiary: PageBackgroundTertiary,
  PaginationNumberedNavigationBackground: PaginationNumberedNavigationBackground,
  PaginationNumberedNavigationBackgroundDisabled: PaginationNumberedNavigationBackgroundDisabled,
  PaginationNumberedNavigationBackgroundHovered: PaginationNumberedNavigationBackgroundHovered,
  PaginationNumberedNavigationBackgroundPressed: PaginationNumberedNavigationBackgroundPressed,
  PaginationNumberedNavigationBorder: PaginationNumberedNavigationBorder,
  PaginationNumberedNavigationBorderDisabled: PaginationNumberedNavigationBorderDisabled,
  PaginationNumberedNavigationBorderHovered: PaginationNumberedNavigationBorderHovered,
  PaginationNumberedNavigationBorderPressed: PaginationNumberedNavigationBorderPressed,
  PaginationNumberedNavigationForeground: PaginationNumberedNavigationForeground,
  PaginationNumberedNavigationForegroundDisabled: PaginationNumberedNavigationForegroundDisabled,
  PaginationNumberedNavigationForegroundHovered: PaginationNumberedNavigationForegroundHovered,
  PaginationNumberedNavigationForegroundPressed: PaginationNumberedNavigationForegroundPressed,
  PaginationNumberedSelectedBackground: PaginationNumberedSelectedBackground,
  PaginationNumberedSelectedBackgroundDisabled: PaginationNumberedSelectedBackgroundDisabled,
  PaginationNumberedSelectedBackgroundHovered: PaginationNumberedSelectedBackgroundHovered,
  PaginationNumberedSelectedBackgroundPressed: PaginationNumberedSelectedBackgroundPressed,
  PaginationNumberedSelectedBorder: PaginationNumberedSelectedBorder,
  PaginationNumberedSelectedBorderDisabled: PaginationNumberedSelectedBorderDisabled,
  PaginationNumberedSelectedBorderHovered: PaginationNumberedSelectedBorderHovered,
  PaginationNumberedSelectedBorderPressed: PaginationNumberedSelectedBorderPressed,
  PaginationNumberedSelectedForeground: PaginationNumberedSelectedForeground,
  PaginationNumberedSelectedForegroundDisabled: PaginationNumberedSelectedForegroundDisabled,
  PaginationNumberedSelectedForegroundHovered: PaginationNumberedSelectedForegroundHovered,
  PaginationNumberedSelectedForegroundPressed: PaginationNumberedSelectedForegroundPressed,
  PaginationNumberedUnselectedBackground: PaginationNumberedUnselectedBackground,
  PaginationNumberedUnselectedBackgroundDisabled: PaginationNumberedUnselectedBackgroundDisabled,
  PaginationNumberedUnselectedBackgroundHovered: PaginationNumberedUnselectedBackgroundHovered,
  PaginationNumberedUnselectedBackgroundPressed: PaginationNumberedUnselectedBackgroundPressed,
  PaginationNumberedUnselectedBorder: PaginationNumberedUnselectedBorder,
  PaginationNumberedUnselectedBorderDisabled: PaginationNumberedUnselectedBorderDisabled,
  PaginationNumberedUnselectedBorderHovered: PaginationNumberedUnselectedBorderHovered,
  PaginationNumberedUnselectedBorderPressed: PaginationNumberedUnselectedBorderPressed,
  PaginationNumberedUnselectedForeground: PaginationNumberedUnselectedForeground,
  PaginationNumberedUnselectedForegroundDisabled: PaginationNumberedUnselectedForegroundDisabled,
  PaginationNumberedUnselectedForegroundHovered: PaginationNumberedUnselectedForegroundHovered,
  PaginationNumberedUnselectedForegroundPressed: PaginationNumberedUnselectedForegroundPressed,
  PaginationSelectedDark: PaginationSelectedDark,
  PaginationSelectedLight: PaginationSelectedLight,
  PaginationSelectedPrimary: PaginationSelectedPrimary,
  PaginationUnselectedDark: PaginationUnselectedDark,
  PaginationUnselectedLight: PaginationUnselectedLight,
  PaginationUnselectedPrimary: PaginationUnselectedPrimary,
  PopoverContainerBackground: PopoverContainerBackground,
  QuantityStepperFloatingCollapsedSelectedBackgroundDefault: QuantityStepperFloatingCollapsedSelectedBackgroundDefault,
  QuantityStepperFloatingCollapsedSelectedBackgroundDisabled: QuantityStepperFloatingCollapsedSelectedBackgroundDisabled,
  QuantityStepperFloatingCollapsedSelectedBackgroundHover: QuantityStepperFloatingCollapsedSelectedBackgroundHover,
  QuantityStepperFloatingCollapsedSelectedBackgroundPressed: QuantityStepperFloatingCollapsedSelectedBackgroundPressed,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed,
  QuantityStepperFloatingCollapsedUnselectedBackgroundDefault: QuantityStepperFloatingCollapsedUnselectedBackgroundDefault,
  QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled: QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled,
  QuantityStepperFloatingCollapsedUnselectedBackgroundHover: QuantityStepperFloatingCollapsedUnselectedBackgroundHover,
  QuantityStepperFloatingCollapsedUnselectedBackgroundPressed: QuantityStepperFloatingCollapsedUnselectedBackgroundPressed,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed,
  QuantityStepperFloatingExpandedBackgroundDefault: QuantityStepperFloatingExpandedBackgroundDefault,
  QuantityStepperFloatingExpandedBackgroundDisabled: QuantityStepperFloatingExpandedBackgroundDisabled,
  QuantityStepperFloatingExpandedBackgroundHover: QuantityStepperFloatingExpandedBackgroundHover,
  QuantityStepperFloatingExpandedBackgroundPressed: QuantityStepperFloatingExpandedBackgroundPressed,
  QuantityStepperFloatingExpandedForegroundPrimaryDefault: QuantityStepperFloatingExpandedForegroundPrimaryDefault,
  QuantityStepperFloatingExpandedForegroundPrimaryDisabled: QuantityStepperFloatingExpandedForegroundPrimaryDisabled,
  QuantityStepperFloatingExpandedForegroundPrimaryHover: QuantityStepperFloatingExpandedForegroundPrimaryHover,
  QuantityStepperFloatingExpandedForegroundPrimaryPressed: QuantityStepperFloatingExpandedForegroundPrimaryPressed,
  QuantityStepperFloatingExpandedForegroundSecondaryDefault: QuantityStepperFloatingExpandedForegroundSecondaryDefault,
  QuantityStepperFloatingExpandedForegroundSecondaryDisabled: QuantityStepperFloatingExpandedForegroundSecondaryDisabled,
  QuantityStepperFloatingExpandedForegroundSecondaryHover: QuantityStepperFloatingExpandedForegroundSecondaryHover,
  QuantityStepperFloatingExpandedForegroundSecondaryPressed: QuantityStepperFloatingExpandedForegroundSecondaryPressed,
  RatingSelected: RatingSelected,
  RatingSelectedDisabled: RatingSelectedDisabled,
  RatingUnselected: RatingUnselected,
  RatingUnselectedDisabled: RatingUnselectedDisabled,
  SliderIcon: SliderIcon,
  SliderIconDisabled: SliderIconDisabled,
  SliderKnobBackground: SliderKnobBackground,
  SliderKnobBackgroundDisabled: SliderKnobBackgroundDisabled,
  SliderKnobBackgroundHovered: SliderKnobBackgroundHovered,
  SliderKnobBackgroundPressed: SliderKnobBackgroundPressed,
  SliderTextOff: SliderTextOff,
  SliderTextOffDisabled: SliderTextOffDisabled,
  SliderTextOn: SliderTextOn,
  SliderTextOnDisabled: SliderTextOnDisabled,
  SliderTrackBackgroundOff: SliderTrackBackgroundOff,
  SliderTrackBackgroundOffDisabled: SliderTrackBackgroundOffDisabled,
  SliderTrackBackgroundOn: SliderTrackBackgroundOn,
  SliderTrackBackgroundOnDisabled: SliderTrackBackgroundOnDisabled,
  SwitchBackgroundOff: SwitchBackgroundOff,
  SwitchBackgroundOffDisabled: SwitchBackgroundOffDisabled,
  SwitchBackgroundOn: SwitchBackgroundOn,
  SwitchBackgroundOnDisabled: SwitchBackgroundOnDisabled,
  SwitchBorderOff: SwitchBorderOff,
  SwitchBorderOffDisabled: SwitchBorderOffDisabled,
  SwitchBorderOn: SwitchBorderOn,
  SwitchBorderOnDisabled: SwitchBorderOnDisabled,
  SwitchForegroundOff: SwitchForegroundOff,
  SwitchForegroundOffDisabled: SwitchForegroundOffDisabled,
  SwitchForegroundOn: SwitchForegroundOn,
  SwitchForegroundOnDisabled: SwitchForegroundOnDisabled,
  SwitchThumbOff: SwitchThumbOff,
  SwitchThumbOffDisabled: SwitchThumbOffDisabled,
  SwitchThumbOn: SwitchThumbOn,
  SwitchThumbOnDisabled: SwitchThumbOnDisabled,
  SwitchTrackOff: SwitchTrackOff,
  SwitchTrackOffDisabled: SwitchTrackOffDisabled,
  SwitchTrackOn: SwitchTrackOn,
  SwitchTrackOnDisabled: SwitchTrackOnDisabled,
  TableBodyCellBackground: TableBodyCellBackground,
  TableHeaderCellBackground: TableHeaderCellBackground,
  TagDefaultBackground: TagDefaultBackground,
  TagDefaultBorder: TagDefaultBorder,
  TagDefaultForeground: TagDefaultForeground,
  TagDefaultIcon: TagDefaultIcon,
  TagHighlightBackground: TagHighlightBackground,
  TagHighlightBorder: TagHighlightBorder,
  TagHighlightDefaultBackground: TagHighlightDefaultBackground,
  TagHighlightDefaultBorder: TagHighlightDefaultBorder,
  TagHighlightDefaultForeground: TagHighlightDefaultForeground,
  TagHighlightDefaultIcon: TagHighlightDefaultIcon,
  TagHighlightEmphasisBackground: TagHighlightEmphasisBackground,
  TagHighlightEmphasisBorder: TagHighlightEmphasisBorder,
  TagHighlightEmphasisForeground: TagHighlightEmphasisForeground,
  TagHighlightEmphasisIcon: TagHighlightEmphasisIcon,
  TagHighlightForeground: TagHighlightForeground,
  TagHighlightIcon: TagHighlightIcon,
  TagHighlightSubduedBackground: TagHighlightSubduedBackground,
  TagHighlightSubduedBorder: TagHighlightSubduedBorder,
  TagHighlightSubduedForeground: TagHighlightSubduedForeground,
  TagHighlightSubduedIcon: TagHighlightSubduedIcon,
  TagInformationalBackground: TagInformationalBackground,
  TagInformationalBorder: TagInformationalBorder,
  TagInformationalDefaultBackground: TagInformationalDefaultBackground,
  TagInformationalDefaultBorder: TagInformationalDefaultBorder,
  TagInformationalDefaultForeground: TagInformationalDefaultForeground,
  TagInformationalDefaultIcon: TagInformationalDefaultIcon,
  TagInformationalEmphasisBackground: TagInformationalEmphasisBackground,
  TagInformationalEmphasisBorder: TagInformationalEmphasisBorder,
  TagInformationalEmphasisForeground: TagInformationalEmphasisForeground,
  TagInformationalEmphasisIcon: TagInformationalEmphasisIcon,
  TagInformationalForeground: TagInformationalForeground,
  TagInformationalIcon: TagInformationalIcon,
  TagInformationalSubduedBackground: TagInformationalSubduedBackground,
  TagInformationalSubduedBorder: TagInformationalSubduedBorder,
  TagInformationalSubduedForeground: TagInformationalSubduedForeground,
  TagInformationalSubduedIcon: TagInformationalSubduedIcon,
  TagNegativeBackground: TagNegativeBackground,
  TagNegativeBorder: TagNegativeBorder,
  TagNegativeDefaultBackground: TagNegativeDefaultBackground,
  TagNegativeDefaultBorder: TagNegativeDefaultBorder,
  TagNegativeDefaultForeground: TagNegativeDefaultForeground,
  TagNegativeDefaultIcon: TagNegativeDefaultIcon,
  TagNegativeEmphasisBackground: TagNegativeEmphasisBackground,
  TagNegativeEmphasisBorder: TagNegativeEmphasisBorder,
  TagNegativeEmphasisForeground: TagNegativeEmphasisForeground,
  TagNegativeEmphasisIcon: TagNegativeEmphasisIcon,
  TagNegativeForeground: TagNegativeForeground,
  TagNegativeIcon: TagNegativeIcon,
  TagNegativeSubduedBackground: TagNegativeSubduedBackground,
  TagNegativeSubduedBorder: TagNegativeSubduedBorder,
  TagNegativeSubduedForeground: TagNegativeSubduedForeground,
  TagNegativeSubduedIcon: TagNegativeSubduedIcon,
  TagPositiveBackground: TagPositiveBackground,
  TagPositiveBorder: TagPositiveBorder,
  TagPositiveDefaultBackground: TagPositiveDefaultBackground,
  TagPositiveDefaultBorder: TagPositiveDefaultBorder,
  TagPositiveDefaultForeground: TagPositiveDefaultForeground,
  TagPositiveDefaultIcon: TagPositiveDefaultIcon,
  TagPositiveEmphasisBackground: TagPositiveEmphasisBackground,
  TagPositiveEmphasisBorder: TagPositiveEmphasisBorder,
  TagPositiveEmphasisForeground: TagPositiveEmphasisForeground,
  TagPositiveEmphasisIcon: TagPositiveEmphasisIcon,
  TagPositiveForeground: TagPositiveForeground,
  TagPositiveIcon: TagPositiveIcon,
  TagPositiveSubduedBackground: TagPositiveSubduedBackground,
  TagPositiveSubduedBorder: TagPositiveSubduedBorder,
  TagPositiveSubduedForeground: TagPositiveSubduedForeground,
  TagPositiveSubduedIcon: TagPositiveSubduedIcon,
  TagWarningBackground: TagWarningBackground,
  TagWarningBorder: TagWarningBorder,
  TagWarningDefaultBackground: TagWarningDefaultBackground,
  TagWarningDefaultBorder: TagWarningDefaultBorder,
  TagWarningDefaultForeground: TagWarningDefaultForeground,
  TagWarningDefaultIcon: TagWarningDefaultIcon,
  TagWarningEmphasisBackground: TagWarningEmphasisBackground,
  TagWarningEmphasisBorder: TagWarningEmphasisBorder,
  TagWarningEmphasisForeground: TagWarningEmphasisForeground,
  TagWarningEmphasisIcon: TagWarningEmphasisIcon,
  TagWarningForeground: TagWarningForeground,
  TagWarningIcon: TagWarningIcon,
  TagWarningSubduedBackground: TagWarningSubduedBackground,
  TagWarningSubduedBorder: TagWarningSubduedBorder,
  TagWarningSubduedForeground: TagWarningSubduedForeground,
  TagWarningSubduedIcon: TagWarningSubduedIcon,
  TextAccentedPrimary: TextAccentedPrimary,
  TextAccentedSecondary: TextAccentedSecondary,
  TextAction: TextAction,
  TextCallout: TextCallout,
  TextDashpass: TextDashpass,
  TextDisabled: TextDisabled,
  TextError: TextError,
  TextHighlight: TextHighlight,
  TextLink: TextLink,
  TextPositive: TextPositive,
  TextPrimary: TextPrimary,
  TextPrimaryOnDark: TextPrimaryOnDark,
  TextSecondary: TextSecondary,
  TextSecondaryOnDark: TextSecondaryOnDark,
  TextSelected: TextSelected,
  TextTertiary: TextTertiary,
  TextTooltip: TextTooltip,
  TextWarning: TextWarning,
  TimelineTrackBackgroundOff: TimelineTrackBackgroundOff,
  TimelineTrackBackgroundOn: TimelineTrackBackgroundOn,
  TimelineTrackForegroundOff: TimelineTrackForegroundOff,
  TimelineTrackForegroundOn: TimelineTrackForegroundOn,
  TimelineTrackShimmer: TimelineTrackShimmer,
  ToastInformationalAction: ToastInformationalAction,
  ToastInformationalActionDisabled: ToastInformationalActionDisabled,
  ToastInformationalActionHovered: ToastInformationalActionHovered,
  ToastInformationalActionPressed: ToastInformationalActionPressed,
  ToastInformationalBackground: ToastInformationalBackground,
  ToastInformationalForeground: ToastInformationalForeground,
  ToggleBackgroundDisabled: ToggleBackgroundDisabled,
  ToggleBackgroundOff: ToggleBackgroundOff,
  ToggleBackgroundOffDisabled: ToggleBackgroundOffDisabled,
  ToggleBackgroundOn: ToggleBackgroundOn,
  ToggleBackgroundOnDisabled: ToggleBackgroundOnDisabled,
  ToggleBorderOff: ToggleBorderOff,
  ToggleBorderOffDisabled: ToggleBorderOffDisabled,
  ToggleBorderOn: ToggleBorderOn,
  ToggleBorderOnDisabled: ToggleBorderOnDisabled,
  ToggleCheckmarkOn: ToggleCheckmarkOn,
  ToggleForegroundOff: ToggleForegroundOff,
  ToggleForegroundOffDisabled: ToggleForegroundOffDisabled,
  ToggleForegroundOn: ToggleForegroundOn,
  ToggleForegroundOnDisabled: ToggleForegroundOnDisabled,
  ToggleTrackBackgroundDisabled: ToggleTrackBackgroundDisabled,
  ToggleTrackBackgroundOff: ToggleTrackBackgroundOff,
  TooltipHighlightBackground: TooltipHighlightBackground,
  TooltipHighlightBackgroundHovered: TooltipHighlightBackgroundHovered,
  TooltipHighlightBackgroundPressed: TooltipHighlightBackgroundPressed,
  TooltipHighlightForeground: TooltipHighlightForeground,
  TooltipHighlightForegroundHovered: TooltipHighlightForegroundHovered,
  TooltipHighlightForegroundPressed: TooltipHighlightForegroundPressed,
  TooltipInformationalBackground: TooltipInformationalBackground,
  TooltipInformationalBackgroundHovered: TooltipInformationalBackgroundHovered,
  TooltipInformationalBackgroundPressed: TooltipInformationalBackgroundPressed,
  TooltipInformationalForeground: TooltipInformationalForeground,
  TooltipInformationalForegroundHovered: TooltipInformationalForegroundHovered,
  TooltipInformationalForegroundPressed: TooltipInformationalForegroundPressed,
  WarningBackground: WarningBackground,
  WarningForeground: WarningForeground
};

export { BackgroundElevated, BackgroundOverlay, BackgroundPrimary, BackgroundPrimaryInverted, BackgroundSecondary, BackgroundSecondaryInverted, BackgroundSeparator, BackgroundTertiary, BannerDefaultBackground, BannerDefaultForeground, BannerDefaultIcon, BannerHighlightBackground, BannerHighlightDefaultBackground, BannerHighlightDefaultForeground, BannerHighlightDefaultIcon, BannerHighlightEmphasisBackground, BannerHighlightEmphasisForeground, BannerHighlightEmphasisIcon, BannerHighlightForeground, BannerHighlightIcon, BannerHighlightSubduedBackground, BannerHighlightSubduedBorder, BannerHighlightSubduedDecorator, BannerHighlightSubduedForeground, BannerHighlightSubduedIcon, BannerHighlightSubduedIconBackground, BannerInformationalBackground, BannerInformationalDefaultBackground, BannerInformationalDefaultForeground, BannerInformationalDefaultIcon, BannerInformationalEmphasisBackground, BannerInformationalEmphasisForeground, BannerInformationalEmphasisIcon, BannerInformationalForeground, BannerInformationalIcon, BannerInformationalSubduedBackground, BannerInformationalSubduedBorder, BannerInformationalSubduedDecorator, BannerInformationalSubduedForeground, BannerInformationalSubduedIcon, BannerInformationalSubduedIconBackground, BannerNegativeBackground, BannerNegativeDefaultBackground, BannerNegativeDefaultForeground, BannerNegativeDefaultIcon, BannerNegativeEmphasisBackground, BannerNegativeEmphasisForeground, BannerNegativeEmphasisIcon, BannerNegativeForeground, BannerNegativeIcon, BannerNegativeSubduedBackground, BannerNegativeSubduedBorder, BannerNegativeSubduedDecorator, BannerNegativeSubduedForeground, BannerNegativeSubduedIcon, BannerNegativeSubduedIconBackground, BannerPositiveBackground, BannerPositiveDefaultBackground, BannerPositiveDefaultForeground, BannerPositiveDefaultIcon, BannerPositiveEmphasisBackground, BannerPositiveEmphasisForeground, BannerPositiveEmphasisIcon, BannerPositiveForeground, BannerPositiveIcon, BannerPositiveSubduedBackground, BannerPositiveSubduedBorder, BannerPositiveSubduedDecorator, BannerPositiveSubduedForeground, BannerPositiveSubduedIcon, BannerPositiveSubduedIconBackground, BannerWarningBackground, BannerWarningDefaultBackground, BannerWarningDefaultForeground, BannerWarningDefaultIcon, BannerWarningEmphasisBackground, BannerWarningEmphasisForeground, BannerWarningEmphasisIcon, BannerWarningForeground, BannerWarningIcon, BannerWarningSubduedBackground, BannerWarningSubduedBorder, BannerWarningSubduedDecorator, BannerWarningSubduedForeground, BannerWarningSubduedIcon, BannerWarningSubduedIconBackground, BorderError, BorderErrorDisabled, BorderFocus, BorderPrimary, BorderSecondary, BreadcrumbText, BreadcrumbTextDisabled, BreadcrumbTextHovered, BreadcrumbTextPressed, ButtonDefaultForeground, ButtonDefaultForegroundDisabled, ButtonDefaultForegroundHovered, ButtonDefaultForegroundPressed, ButtonDefaultToggleForeground, ButtonDefaultToggleForegroundDisabled, ButtonDefaultToggleForegroundHovered, ButtonDefaultToggleForegroundOff, ButtonDefaultToggleForegroundOffDisabled, ButtonDefaultToggleForegroundOffHovered, ButtonDefaultToggleForegroundOffPressed, ButtonDefaultToggleForegroundPressed, ButtonDestructiveBackground, ButtonDestructiveBackgroundDisabled, ButtonDestructiveBackgroundHovered, ButtonDestructiveBackgroundPressed, ButtonDestructiveForeground, ButtonDestructiveForegroundDisabled, ButtonDestructiveForegroundHovered, ButtonDestructiveForegroundPressed, ButtonFabBackground, ButtonFabBackgroundDisabled, ButtonFabBackgroundHovered, ButtonFabBackgroundPressed, ButtonFabForeground, ButtonFabForegroundDisabled, ButtonFabForegroundHovered, ButtonFabForegroundPressed, ButtonFlatPrimaryBackground, ButtonFlatPrimaryBackgroundDisabled, ButtonFlatPrimaryBackgroundHovered, ButtonFlatPrimaryBackgroundPressed, ButtonFlatPrimaryForeground, ButtonFlatPrimaryForegroundDisabled, ButtonFlatPrimaryForegroundHovered, ButtonFlatPrimaryForegroundPressed, ButtonFlatSecondaryBackground, ButtonFlatSecondaryBackgroundDisabled, ButtonFlatSecondaryBackgroundHovered, ButtonFlatSecondaryBackgroundPressed, ButtonFlatSecondaryForeground, ButtonFlatSecondaryForegroundDisabled, ButtonFlatSecondaryForegroundHovered, ButtonFlatSecondaryForegroundPressed, ButtonFloatingToggleGroupBackgroundColorOff, ButtonLinkForeground, ButtonLinkForegroundDisabled, ButtonLinkForegroundHovered, ButtonLinkForegroundPressed, ButtonPlainBackground, ButtonPlainBackgroundDisabled, ButtonPlainBackgroundHovered, ButtonPlainBackgroundPressed, ButtonPlainForeground, ButtonPlainForegroundDisabled, ButtonPlainForegroundHovered, ButtonPlainForegroundPressed, ButtonPlainToggleBackground, ButtonPlainToggleBackgroundDisabled, ButtonPlainToggleBackgroundHovered, ButtonPlainToggleBackgroundOff, ButtonPlainToggleBackgroundOffDisabled, ButtonPlainToggleBackgroundOffHovered, ButtonPlainToggleBackgroundOffPressed, ButtonPlainToggleBackgroundPressed, ButtonPlainToggleForeground, ButtonPlainToggleForegroundDisabled, ButtonPlainToggleForegroundHovered, ButtonPlainToggleForegroundOff, ButtonPlainToggleForegroundOffDisabled, ButtonPlainToggleForegroundOffHovered, ButtonPlainToggleForegroundOffPressed, ButtonPlainToggleForegroundPressed, ButtonPrimaryBackground, ButtonPrimaryBackgroundDisabled, ButtonPrimaryBackgroundHovered, ButtonPrimaryBackgroundPressed, ButtonPrimaryForeground, ButtonPrimaryForegroundDisabled, ButtonPrimaryForegroundHovered, ButtonPrimaryForegroundPressed, ButtonPrimaryToggleBackground, ButtonPrimaryToggleBackgroundDisabled, ButtonPrimaryToggleBackgroundHovered, ButtonPrimaryToggleBackgroundOff, ButtonPrimaryToggleBackgroundOffDisabled, ButtonPrimaryToggleBackgroundOffHovered, ButtonPrimaryToggleBackgroundOffPressed, ButtonPrimaryToggleBackgroundPressed, ButtonPrimaryToggleBorderOff, ButtonPrimaryToggleBorderOffDisabled, ButtonPrimaryToggleBorderOffHovered, ButtonPrimaryToggleBorderOffPressed, ButtonPrimaryToggleBorderOn, ButtonPrimaryToggleBorderOnDisabled, ButtonPrimaryToggleBorderOnHovered, ButtonPrimaryToggleBorderOnPressed, ButtonPrimaryToggleForeground, ButtonPrimaryToggleForegroundDisabled, ButtonPrimaryToggleForegroundHovered, ButtonPrimaryToggleForegroundOff, ButtonPrimaryToggleForegroundOffDisabled, ButtonPrimaryToggleForegroundOffHovered, ButtonPrimaryToggleForegroundOffPressed, ButtonPrimaryToggleForegroundPressed, ButtonPrimaryToggleGroupBackgroundOff, ButtonPrimaryToggleGroupBackgroundOffDisabled, ButtonPrimaryToggleGroupBackgroundOffHovered, ButtonPrimaryToggleGroupBackgroundOffPressed, ButtonPrimaryToggleGroupBackgroundOn, ButtonPrimaryToggleGroupBackgroundOnDisabled, ButtonPrimaryToggleGroupBackgroundOnHovered, ButtonPrimaryToggleGroupBackgroundOnPressed, ButtonPrimaryToggleGroupBorderOff, ButtonPrimaryToggleGroupBorderOffDisabled, ButtonPrimaryToggleGroupBorderOffHovered, ButtonPrimaryToggleGroupBorderOffPressed, ButtonPrimaryToggleGroupBorderOn, ButtonPrimaryToggleGroupBorderOnDisabled, ButtonPrimaryToggleGroupBorderOnHovered, ButtonPrimaryToggleGroupBorderOnPressed, ButtonPrimaryToggleGroupForegroundOff, ButtonPrimaryToggleGroupForegroundOffDisabled, ButtonPrimaryToggleGroupForegroundOffHovered, ButtonPrimaryToggleGroupForegroundOffPressed, ButtonPrimaryToggleGroupForegroundOn, ButtonPrimaryToggleGroupForegroundOnDisabled, ButtonPrimaryToggleGroupForegroundOnHovered, ButtonPrimaryToggleGroupForegroundOnPressed, ButtonSecondaryBackground, ButtonSecondaryBackgroundDisabled, ButtonSecondaryBackgroundHovered, ButtonSecondaryBackgroundPressed, ButtonSecondaryForeground, ButtonSecondaryForegroundDisabled, ButtonSecondaryForegroundHovered, ButtonSecondaryForegroundPressed, ButtonSecondaryToggleBackground, ButtonSecondaryToggleBackgroundDisabled, ButtonSecondaryToggleBackgroundHovered, ButtonSecondaryToggleBackgroundOff, ButtonSecondaryToggleBackgroundOffDisabled, ButtonSecondaryToggleBackgroundOffHovered, ButtonSecondaryToggleBackgroundOffPressed, ButtonSecondaryToggleBackgroundPressed, ButtonSecondaryToggleBorderOff, ButtonSecondaryToggleBorderOffDisabled, ButtonSecondaryToggleBorderOffHovered, ButtonSecondaryToggleBorderOffPressed, ButtonSecondaryToggleBorderOn, ButtonSecondaryToggleBorderOnDisabled, ButtonSecondaryToggleBorderOnHovered, ButtonSecondaryToggleBorderOnPressed, ButtonSecondaryToggleForeground, ButtonSecondaryToggleForegroundDisabled, ButtonSecondaryToggleForegroundHovered, ButtonSecondaryToggleForegroundOff, ButtonSecondaryToggleForegroundOffDisabled, ButtonSecondaryToggleForegroundOffHovered, ButtonSecondaryToggleForegroundOffPressed, ButtonSecondaryToggleForegroundPressed, ButtonSecondaryToggleGroupBackgroundOff, ButtonSecondaryToggleGroupBackgroundOffDisabled, ButtonSecondaryToggleGroupBackgroundOffHovered, ButtonSecondaryToggleGroupBackgroundOffPressed, ButtonSecondaryToggleGroupBackgroundOn, ButtonSecondaryToggleGroupBackgroundOnDisabled, ButtonSecondaryToggleGroupBackgroundOnHovered, ButtonSecondaryToggleGroupBackgroundOnPressed, ButtonSecondaryToggleGroupBorderOff, ButtonSecondaryToggleGroupBorderOffDisabled, ButtonSecondaryToggleGroupBorderOffHovered, ButtonSecondaryToggleGroupBorderOffPressed, ButtonSecondaryToggleGroupBorderOn, ButtonSecondaryToggleGroupBorderOnDisabled, ButtonSecondaryToggleGroupBorderOnHovered, ButtonSecondaryToggleGroupBorderOnPressed, ButtonSecondaryToggleGroupForegroundOff, ButtonSecondaryToggleGroupForegroundOffDisabled, ButtonSecondaryToggleGroupForegroundOffHovered, ButtonSecondaryToggleGroupForegroundOffPressed, ButtonSecondaryToggleGroupForegroundOn, ButtonSecondaryToggleGroupForegroundOnDisabled, ButtonSecondaryToggleGroupForegroundOnHovered, ButtonSecondaryToggleGroupForegroundOnPressed, ButtonTabBackgroundOffDefault, ButtonTabBackgroundOffDisabled, ButtonTabBackgroundOffHovered, ButtonTabBackgroundOffPressed, ButtonTabBackgroundOnDefault, ButtonTabBackgroundOnDisabled, ButtonTabBackgroundOnHovered, ButtonTabBackgroundOnPressed, ButtonTabForegroundOffDefault, ButtonTabForegroundOffDisabled, ButtonTabForegroundOffHovered, ButtonTabForegroundOffPressed, ButtonTabForegroundOnDefault, ButtonTabForegroundOnDisabled, ButtonTabForegroundOnHovered, ButtonTabForegroundOnPressed, ButtonTertiaryBackground, ButtonTertiaryBackgroundDisabled, ButtonTertiaryBackgroundHovered, ButtonTertiaryBackgroundPressed, ButtonTertiaryBorder, ButtonTertiaryBorderDisabled, ButtonTertiaryBorderHovered, ButtonTertiaryBorderPressed, ButtonTertiaryForeground, ButtonTertiaryForegroundDisabled, ButtonTertiaryForegroundHovered, ButtonTertiaryForegroundPressed, ButtonTertiaryToggleBackground, ButtonTertiaryToggleBackgroundDisabled, ButtonTertiaryToggleBackgroundHovered, ButtonTertiaryToggleBackgroundOff, ButtonTertiaryToggleBackgroundOffDisabled, ButtonTertiaryToggleBackgroundOffHovered, ButtonTertiaryToggleBackgroundOffPressed, ButtonTertiaryToggleBackgroundPressed, ButtonTertiaryToggleBorderOff, ButtonTertiaryToggleBorderOffDisabled, ButtonTertiaryToggleBorderOffHovered, ButtonTertiaryToggleBorderOffPressed, ButtonTertiaryToggleBorderOn, ButtonTertiaryToggleBorderOnDisabled, ButtonTertiaryToggleBorderOnHovered, ButtonTertiaryToggleBorderOnPressed, ButtonTertiaryToggleForeground, ButtonTertiaryToggleForegroundDisabled, ButtonTertiaryToggleForegroundHovered, ButtonTertiaryToggleForegroundOff, ButtonTertiaryToggleForegroundOffDisabled, ButtonTertiaryToggleForegroundOffHovered, ButtonTertiaryToggleForegroundOffPressed, ButtonTertiaryToggleForegroundPressed, ButtonTertiaryToggleGroupBackgroundOff, ButtonTertiaryToggleGroupBackgroundOffDisabled, ButtonTertiaryToggleGroupBackgroundOffHovered, ButtonTertiaryToggleGroupBackgroundOffPressed, ButtonTertiaryToggleGroupBackgroundOn, ButtonTertiaryToggleGroupBackgroundOnDisabled, ButtonTertiaryToggleGroupBackgroundOnHovered, ButtonTertiaryToggleGroupBackgroundOnPressed, ButtonTertiaryToggleGroupBorderOff, ButtonTertiaryToggleGroupBorderOffDisabled, ButtonTertiaryToggleGroupBorderOffHovered, ButtonTertiaryToggleGroupBorderOffPressed, ButtonTertiaryToggleGroupBorderOn, ButtonTertiaryToggleGroupBorderOnDisabled, ButtonTertiaryToggleGroupBorderOnHovered, ButtonTertiaryToggleGroupBorderOnPressed, ButtonTertiaryToggleGroupForegroundOff, ButtonTertiaryToggleGroupForegroundOffDisabled, ButtonTertiaryToggleGroupForegroundOffHovered, ButtonTertiaryToggleGroupForegroundOffPressed, ButtonTertiaryToggleGroupForegroundOn, ButtonTertiaryToggleGroupForegroundOnDisabled, ButtonTertiaryToggleGroupForegroundOnHovered, ButtonTertiaryToggleGroupForegroundOnPressed, CardBackgroundDefault, CardBackgroundDisabled, CardBackgroundHovered, CardBackgroundPressed, CardBodyDefault, CardBodyDisabled, CardBodyHovered, CardBodyPressed, CardBorderSelectedDefault, CardBorderSelectedDisabled, CardBorderSelectedError, CardBorderSelectedErrorDisabled, CardBorderSelectedHovered, CardBorderSelectedPressed, CardBorderUnselectedDefault, CardBorderUnselectedDisabled, CardBorderUnselectedError, CardBorderUnselectedErrorDisabled, CardBorderUnselectedHovered, CardBorderUnselectedPressed, CardTitleDefault, CardTitleDisabled, CardTitleHovered, CardTitlePressed, ChatIncomingBackground, ChatIncomingForeground, ChatOutgoingBackground, ChatOutgoingForeground, ColorSemanticsAll, DatePickerDateBorderSelected, DatePickerDateBorderSelectedDisabled, DatePickerDateBorderSelectedHovered, DatePickerDateBorderSelectedPressed, DatePickerDateBorderUnselected, DatePickerDateBorderUnselectedDisabled, DatePickerDateBorderUnselectedHovered, DatePickerDateBorderUnselectedPressed, DatePickerDateForegroundSelected, DatePickerDateForegroundSelectedDisabled, DatePickerDateForegroundSelectedHovered, DatePickerDateForegroundSelectedPressed, DatePickerDateForegroundUnselected, DatePickerDateForegroundUnselectedDisabled, DatePickerDateForegroundUnselectedHovered, DatePickerDateForegroundUnselectedPressed, DatePickerDateSelectedBackground, DatePickerDateSelectedBackgroundDisabled, DatePickerDateSelectedBackgroundHovered, DatePickerDateSelectedBackgroundPressed, DatePickerDateSelectedIndicatorDisabled, DatePickerDateSelectedIndicatorPrimary, DatePickerDateSelectedIndicatorSecondary, DatePickerDateUnselectedBackground, DatePickerDateUnselectedBackgroundDisabled, DatePickerDateUnselectedBackgroundHovered, DatePickerDateUnselectedBackgroundPressed, DatePickerDateUnselectedIndicatorDisabled, DatePickerDateUnselectedIndicatorPrimary, DatePickerDateUnselectedIndicatorSecondary, DatePickerRangeBorderSelected, DatePickerRangeBorderSelectedDisabled, DatePickerRangeBorderSelectedHovered, DatePickerRangeBorderSelectedPressed, DatePickerRangeBorderUnselected, DatePickerRangeBorderUnselectedDisabled, DatePickerRangeBorderUnselectedHovered, DatePickerRangeBorderUnselectedPressed, DatePickerRangeForegroundSelected, DatePickerRangeForegroundSelectedDisabled, DatePickerRangeForegroundSelectedHovered, DatePickerRangeForegroundSelectedPressed, DatePickerRangeForegroundUnselected, DatePickerRangeForegroundUnselectedDisabled, DatePickerRangeForegroundUnselectedHovered, DatePickerRangeForegroundUnselectedPressed, DatePickerRangeSelectedBackground, DatePickerRangeSelectedBackgroundDisabled, DatePickerRangeSelectedBackgroundHovered, DatePickerRangeSelectedBackgroundPressed, DatePickerRangeSelectedIndicatorDisabled, DatePickerRangeSelectedIndicatorPrimary, DatePickerRangeSelectedIndicatorSecondary, DatePickerRangeUnselectedBackground, DatePickerRangeUnselectedBackgroundDisabled, DatePickerRangeUnselectedBackgroundHovered, DatePickerRangeUnselectedBackgroundPressed, DatePickerTodayBorderSelected, DiagonalDefaultOverlay, FieldsBackgroundActive, FieldsBackgroundDisabled, FieldsBackgroundError, FieldsBackgroundInactive, FieldsBorderActive, FieldsBorderDisabled, FieldsBorderError, FieldsBorderInactive, FieldsForegroundActive, FieldsForegroundDisabled, FieldsForegroundError, FieldsForegroundInactive, FieldsForegroundPlaceholder, FieldsIconDropdown, FieldsIconSearch, FieldsInputBackground, FieldsInputBackgroundDisabled, FieldsInputBorder, FieldsInputBorderError, GlobalPrimary, GlobalSecondary, ListCellContainerBackgroundDefault, ListCellContainerBackgroundHovered, ListCellContainerBackgroundPressed, ListCellContainerBackgroundUnread, ListCellContainerBackgroundUnreadHovered, ListCellContainerBackgroundUnreadPressed, ListCellIconToggledOff, ListCellIconToggledOn, LoadingDefault, MapCurrentLocationBackgroundDefault, MapCurrentLocationBackgroundOverlay, MapCurrentLocationBorder, MapDasherBackground, MapDasherBorder, MapDasherForeground, MapPinSelectedBackgroundDefault, MapPinSelectedBackgroundDisabled, MapPinSelectedBorderDefault, MapPinSelectedBorderDisabled, MapPinSelectedForegroundDefault, MapPinSelectedForegroundDisabled, MapPinUnselectedBackgroundDefault, MapPinUnselectedBackgroundDisabled, MapPinUnselectedBorderDefault, MapPinUnselectedBorderDisabled, MapPinUnselectedForegroundAlcohol, MapPinUnselectedForegroundCoffee, MapPinUnselectedForegroundDefault, MapPinUnselectedForegroundDisabled, MapPinUnselectedForegroundFood, MapPinUnselectedForegroundGroceries, MapRoutelineBackgroundDefault, MapRoutelineBorder, MapRoutelineNodeBackgroundDefault, MapRoutelineNodeBorder, MenuItemBackground, MenuItemBackgroundDisabled, MenuItemBackgroundHovered, MenuItemBackgroundPressed, MenuItemForeground, MenuItemForegroundDisabled, MenuItemForegroundHovered, MenuItemForegroundPressed, ModalBackground, OverlayBackgroundDefault, OverlayBackgroundLoading, OverlayLoadingDefault, PageBackgroundPrimary, PageBackgroundSecondary, PageBackgroundTertiary, PaginationNumberedNavigationBackground, PaginationNumberedNavigationBackgroundDisabled, PaginationNumberedNavigationBackgroundHovered, PaginationNumberedNavigationBackgroundPressed, PaginationNumberedNavigationBorder, PaginationNumberedNavigationBorderDisabled, PaginationNumberedNavigationBorderHovered, PaginationNumberedNavigationBorderPressed, PaginationNumberedNavigationForeground, PaginationNumberedNavigationForegroundDisabled, PaginationNumberedNavigationForegroundHovered, PaginationNumberedNavigationForegroundPressed, PaginationNumberedSelectedBackground, PaginationNumberedSelectedBackgroundDisabled, PaginationNumberedSelectedBackgroundHovered, PaginationNumberedSelectedBackgroundPressed, PaginationNumberedSelectedBorder, PaginationNumberedSelectedBorderDisabled, PaginationNumberedSelectedBorderHovered, PaginationNumberedSelectedBorderPressed, PaginationNumberedSelectedForeground, PaginationNumberedSelectedForegroundDisabled, PaginationNumberedSelectedForegroundHovered, PaginationNumberedSelectedForegroundPressed, PaginationNumberedUnselectedBackground, PaginationNumberedUnselectedBackgroundDisabled, PaginationNumberedUnselectedBackgroundHovered, PaginationNumberedUnselectedBackgroundPressed, PaginationNumberedUnselectedBorder, PaginationNumberedUnselectedBorderDisabled, PaginationNumberedUnselectedBorderHovered, PaginationNumberedUnselectedBorderPressed, PaginationNumberedUnselectedForeground, PaginationNumberedUnselectedForegroundDisabled, PaginationNumberedUnselectedForegroundHovered, PaginationNumberedUnselectedForegroundPressed, PaginationSelectedDark, PaginationSelectedLight, PaginationSelectedPrimary, PaginationUnselectedDark, PaginationUnselectedLight, PaginationUnselectedPrimary, PopoverContainerBackground, QuantityStepperFloatingCollapsedSelectedBackgroundDefault, QuantityStepperFloatingCollapsedSelectedBackgroundDisabled, QuantityStepperFloatingCollapsedSelectedBackgroundHover, QuantityStepperFloatingCollapsedSelectedBackgroundPressed, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed, QuantityStepperFloatingCollapsedUnselectedBackgroundDefault, QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled, QuantityStepperFloatingCollapsedUnselectedBackgroundHover, QuantityStepperFloatingCollapsedUnselectedBackgroundPressed, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed, QuantityStepperFloatingExpandedBackgroundDefault, QuantityStepperFloatingExpandedBackgroundDisabled, QuantityStepperFloatingExpandedBackgroundHover, QuantityStepperFloatingExpandedBackgroundPressed, QuantityStepperFloatingExpandedForegroundPrimaryDefault, QuantityStepperFloatingExpandedForegroundPrimaryDisabled, QuantityStepperFloatingExpandedForegroundPrimaryHover, QuantityStepperFloatingExpandedForegroundPrimaryPressed, QuantityStepperFloatingExpandedForegroundSecondaryDefault, QuantityStepperFloatingExpandedForegroundSecondaryDisabled, QuantityStepperFloatingExpandedForegroundSecondaryHover, QuantityStepperFloatingExpandedForegroundSecondaryPressed, RatingSelected, RatingSelectedDisabled, RatingUnselected, RatingUnselectedDisabled, SliderIcon, SliderIconDisabled, SliderKnobBackground, SliderKnobBackgroundDisabled, SliderKnobBackgroundHovered, SliderKnobBackgroundPressed, SliderTextOff, SliderTextOffDisabled, SliderTextOn, SliderTextOnDisabled, SliderTrackBackgroundOff, SliderTrackBackgroundOffDisabled, SliderTrackBackgroundOn, SliderTrackBackgroundOnDisabled, SwitchBackgroundOff, SwitchBackgroundOffDisabled, SwitchBackgroundOn, SwitchBackgroundOnDisabled, SwitchBorderOff, SwitchBorderOffDisabled, SwitchBorderOn, SwitchBorderOnDisabled, SwitchForegroundOff, SwitchForegroundOffDisabled, SwitchForegroundOn, SwitchForegroundOnDisabled, SwitchThumbOff, SwitchThumbOffDisabled, SwitchThumbOn, SwitchThumbOnDisabled, SwitchTrackOff, SwitchTrackOffDisabled, SwitchTrackOn, SwitchTrackOnDisabled, TableBodyCellBackground, TableHeaderCellBackground, TagDefaultBackground, TagDefaultBorder, TagDefaultForeground, TagDefaultIcon, TagHighlightBackground, TagHighlightBorder, TagHighlightDefaultBackground, TagHighlightDefaultBorder, TagHighlightDefaultForeground, TagHighlightDefaultIcon, TagHighlightEmphasisBackground, TagHighlightEmphasisBorder, TagHighlightEmphasisForeground, TagHighlightEmphasisIcon, TagHighlightForeground, TagHighlightIcon, TagHighlightSubduedBackground, TagHighlightSubduedBorder, TagHighlightSubduedForeground, TagHighlightSubduedIcon, TagInformationalBackground, TagInformationalBorder, TagInformationalDefaultBackground, TagInformationalDefaultBorder, TagInformationalDefaultForeground, TagInformationalDefaultIcon, TagInformationalEmphasisBackground, TagInformationalEmphasisBorder, TagInformationalEmphasisForeground, TagInformationalEmphasisIcon, TagInformationalForeground, TagInformationalIcon, TagInformationalSubduedBackground, TagInformationalSubduedBorder, TagInformationalSubduedForeground, TagInformationalSubduedIcon, TagNegativeBackground, TagNegativeBorder, TagNegativeDefaultBackground, TagNegativeDefaultBorder, TagNegativeDefaultForeground, TagNegativeDefaultIcon, TagNegativeEmphasisBackground, TagNegativeEmphasisBorder, TagNegativeEmphasisForeground, TagNegativeEmphasisIcon, TagNegativeForeground, TagNegativeIcon, TagNegativeSubduedBackground, TagNegativeSubduedBorder, TagNegativeSubduedForeground, TagNegativeSubduedIcon, TagPositiveBackground, TagPositiveBorder, TagPositiveDefaultBackground, TagPositiveDefaultBorder, TagPositiveDefaultForeground, TagPositiveDefaultIcon, TagPositiveEmphasisBackground, TagPositiveEmphasisBorder, TagPositiveEmphasisForeground, TagPositiveEmphasisIcon, TagPositiveForeground, TagPositiveIcon, TagPositiveSubduedBackground, TagPositiveSubduedBorder, TagPositiveSubduedForeground, TagPositiveSubduedIcon, TagWarningBackground, TagWarningBorder, TagWarningDefaultBackground, TagWarningDefaultBorder, TagWarningDefaultForeground, TagWarningDefaultIcon, TagWarningEmphasisBackground, TagWarningEmphasisBorder, TagWarningEmphasisForeground, TagWarningEmphasisIcon, TagWarningForeground, TagWarningIcon, TagWarningSubduedBackground, TagWarningSubduedBorder, TagWarningSubduedForeground, TagWarningSubduedIcon, TextAccentedPrimary, TextAccentedSecondary, TextAction, TextCallout, TextDashpass, TextDisabled, TextError, TextHighlight, TextLink, TextPositive, TextPrimary, TextPrimaryOnDark, TextSecondary, TextSecondaryOnDark, TextSelected, TextTertiary, TextTooltip, TextWarning, TimelineTrackBackgroundOff, TimelineTrackBackgroundOn, TimelineTrackForegroundOff, TimelineTrackForegroundOn, TimelineTrackShimmer, ToastInformationalAction, ToastInformationalActionDisabled, ToastInformationalActionHovered, ToastInformationalActionPressed, ToastInformationalBackground, ToastInformationalForeground, ToggleBackgroundDisabled, ToggleBackgroundOff, ToggleBackgroundOffDisabled, ToggleBackgroundOn, ToggleBackgroundOnDisabled, ToggleBorderOff, ToggleBorderOffDisabled, ToggleBorderOn, ToggleBorderOnDisabled, ToggleCheckmarkOn, ToggleForegroundOff, ToggleForegroundOffDisabled, ToggleForegroundOn, ToggleForegroundOnDisabled, ToggleTrackBackgroundDisabled, ToggleTrackBackgroundOff, TooltipHighlightBackground, TooltipHighlightBackgroundHovered, TooltipHighlightBackgroundPressed, TooltipHighlightForeground, TooltipHighlightForegroundHovered, TooltipHighlightForegroundPressed, TooltipInformationalBackground, TooltipInformationalBackgroundHovered, TooltipInformationalBackgroundPressed, TooltipInformationalForeground, TooltipInformationalForegroundHovered, TooltipInformationalForegroundPressed, WarningBackground, WarningForeground, ColorSemanticsAll as default };
